var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-1",
    cx: 250,
    cy: 353.18,
    rx: 243.68,
    ry: 140.69,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-1",
    d: "M77.72,445.49l23.83,13.76a9.57,9.57,0,0,0,8.66,0L260,372.78c2.39-1.38,2.39-3.62,0-5L236.13,354a9.57,9.57,0,0,0-8.66,0L77.72,440.49C75.33,441.87,75.33,444.11,77.72,445.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1",
    d: "M437.67,376.11,487,347.66a1.27,1.27,0,0,0,0-2.4l-122-70.67a4.59,4.59,0,0,0-4.16,0L311.55,303a1.27,1.27,0,0,0,0,2.4l122,70.67A4.57,4.57,0,0,0,437.67,376.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1",
    d: "M47.32,390c-14.4,8.31-14.4,21.79,0,30.11s37.75,8.31,52.15,0,14.4-21.8,0-30.11S61.72,381.64,47.32,390Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-1",
    cx: 364.59,
    cy: 411.85,
    rx: 77.18,
    ry: 44.56,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drawer--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "427.11 347.29 431.35 368.32 435.47 370.69 439.55 368.34 443.82 347.29 435.46 342.46 427.11 347.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.11 347.29 431.35 368.32 435.47 370.69 439.55 368.34 443.82 347.29 435.46 342.46 427.11 347.29",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.47 370.69 435.47 352.12 427.11 347.29 431.35 368.32 435.47 370.69",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.11 347.29 429.85 360.87 435.47 364.11 441.06 360.88 443.82 347.29 435.46 342.46 427.11 347.29",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.86 326.07 468.1 347.1 472.22 349.48 476.3 347.12 480.58 326.07 472.22 321.25 463.86 326.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.86 326.07 468.1 347.1 472.22 349.48 476.3 347.12 480.58 326.07 472.22 321.25 463.86 326.07",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.22 349.48 472.22 330.9 463.86 326.07 468.1 347.1 472.22 349.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.86 326.07 466.6 339.65 472.22 342.89 477.82 339.66 480.58 326.07 472.22 321.25 463.86 326.07",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.39 284.52 322.63 305.55 326.75 307.92 330.83 305.57 335.11 284.52 326.75 279.69 318.39 284.52",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.75 307.92 326.75 289.35 318.39 284.52 322.63 305.55 326.75 307.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.39 284.52 321.13 298.1 326.75 301.34 332.35 298.11 335.11 284.52 326.75 279.69 318.39 284.52",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinet--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "435.47 360.72 481.01 334.42 481.01 235.84 435.47 262.14 435.47 360.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.47 262.14 316.02 193.18 316.02 291.76 435.47 360.72 435.47 262.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.02 193.18 435.47 262.14 481.01 235.84 361.57 166.88 316.02 193.18",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.96 310.98 322.53 249.53 322.53 285.7 321.33 286.4 427.76 347.85 428.96 347.15 428.96 310.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.76 311.67 321.33 250.22 321.33 286.4 427.76 347.85 427.76 311.67",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.59,289l-8.85-5.11c-1.15-.66-2.08-.36-2.08.68a4.19,4.19,0,0,0,2.08,3.08l8.86,5.11c1.15.66,2.08.36,2.08-.68A4.17,4.17,0,0,0,376.59,289Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.96 267.29 322.53 205.84 322.53 242.02 321.33 242.71 427.77 304.16 428.96 303.47 428.96 267.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.76 267.98 321.33 206.53 321.33 242.71 427.77 304.16 427.76 267.98",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.6,245.28l-8.86-5.11c-1.14-.67-2.08-.36-2.08.67a4.18,4.18,0,0,0,2.08,3.08L376.6,249c1.15.67,2.08.36,2.08-.67A4.15,4.15,0,0,0,376.6,245.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.28,183.25c-5.52,3.18-5.52,8.35,0,11.54s14.47,3.19,20,0,5.52-8.36,0-11.54S355.8,180.06,350.28,183.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.07,189.73c4.81-4.91,7.64-17.16,2.94-21H348.15c-4.69,3.89-1.87,16.14,2.94,21l.13.13.17.16c.13.13.28.26.43.39l.12.09.36.27a5.93,5.93,0,0,0,.62.4,15.84,15.84,0,0,0,14.32,0h0a7.2,7.2,0,0,0,.62-.4l.34-.25.14-.12a5,5,0,0,0,.42-.37l.19-.19A.57.57,0,0,0,369.07,189.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.22,167.11c-5.44,3.15-5.44,8.24,0,11.39s14.28,3.14,19.72,0,5.45-8.24,0-11.39S355.67,164,350.22,167.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.08,169.34c-3.31,1.92-3.31,5,0,6.93a13.28,13.28,0,0,0,12,0c3.31-1.91,3.31-5,0-6.93A13.28,13.28,0,0,0,354.08,169.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.08,172.63a13.28,13.28,0,0,0-12,0,5.52,5.52,0,0,0-2,1.82,5.52,5.52,0,0,0,2,1.82,13.28,13.28,0,0,0,12,0,5.56,5.56,0,0,0,2-1.82A5.56,5.56,0,0,0,366.08,172.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.82,174.45a27.2,27.2,0,0,1-4.34-5.77c-2-3.54-2.38-8.29-1.34-8.87s5.25,4.14,5.25,4.14a25.54,25.54,0,0,1-.44-6c.17-3.16.94-6,1.85-6.61s2.92,3.41,3.79,6.29,1.38,5.26,1.38,5.26a45.36,45.36,0,0,1,1.56-6.64c1.05-3,2-3.67,2.74-3.38s1.23,1.7,1.45,5.69a39.69,39.69,0,0,1-.18,5.71s1.49-1.64,3.14-3.22c1.81-1.75,2.59-2,3.1-1.65s.67,3-2.14,8.11a28.52,28.52,0,0,1-5.3,7S361.45,177,354.82,174.45Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "450.16 240.64 448.38 241.49 415.53 222.53 417.31 221.67 450.16 240.64",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.31 221.67 448.56 239.71 453.1 192.97 421.85 174.94 417.31 221.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.19,224.08l38.89,22.46,5.36-55.13L417.55,169ZM420.25,174l32.85,19-4.72,48.52-32.85-19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.53 222.53 417.31 221.67 421.85 174.94 420.25 174 415.53 222.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.55 168.96 419.35 168.12 458.24 190.58 456.44 191.41 417.55 168.96",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.24 190.58 456.44 191.41 451.08 246.54 452.88 245.71 458.24 190.58",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "418.68 220.78 447.49 237.41 448.25 229.54 442.9 206.41 437.79 214.3 438.85 220.95 430.33 196.41 419.45 212.91 418.68 220.78",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.34,196.67a4,4,0,0,1,1.9,3.56c-.12,1.29-1.18,1.78-2.35,1.1a4.06,4.06,0,0,1-1.91-3.56C441.11,196.48,442.16,196,443.34,196.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "468.09 164.81 466 166.06 423.13 141.3 425.22 140.06 468.09 164.81",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.22 140.06 466 163.6 466 52.88 425.22 29.35 425.22 140.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.18,143.58l50.76,29.31V50.61L419.18,21.3Zm3.95-115.45L466,52.88V166.06L423.13,141.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 141.3 425.22 140.06 425.22 29.35 423.13 28.13 423.13 141.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.18 21.3 421.31 20.08 472.07 49.39 469.94 50.6 419.18 21.3",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.07 49.39 469.94 50.6 469.94 172.89 472.07 171.67 472.07 49.39",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "428.28 137.62 462.94 157.63 462.94 56.57 428.28 36.55 428.28 137.62",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "428.28 137.62 462.94 157.63 462.94 56.57 428.28 36.55 428.28 137.62",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M462.94,123.19a32.72,32.72,0,0,1-4.95,0,62.68,62.68,0,0,1-16.89-3.68c-4.19-1.54-8.38-3.55-12.82-3.68v21.83l4.69,2.71a15.9,15.9,0,0,1,6.44-3.58c6.68-1.75,13.53,1.61,20.39,2.39a27.4,27.4,0,0,0,3.14.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.94,95.62c-7.75-2.3-15.71-4.21-21.25-9.9-4.46-4.58-6.56-10.94-8-17.17s-2.47-12.65-5.29-18.4a1.29,1.29,0,0,1-.09-.16V94.44c.43.65.86,1.29,1.33,1.92,5.09,6.9,12.6,12.67,21.16,13.11,4,.21,8.19-.73,12.17-.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.94,75.6a23.65,23.65,0,0,1-7.68-21.51c.11-.58.25-1.16.39-1.73l-13.33-7.7c.05.88.09,1.76.12,2.63.14,5.09,0,10.25,1.09,15.22a29.88,29.88,0,0,0,15.19,19.63,28.27,28.27,0,0,0,4.22,1.76Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "35.44 249.02 37.69 250.36 129.49 197.36 127.23 196.02 35.44 249.02",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.23 196.02 37.69 247.71 37.69 81.77 127.23 30.1 127.23 196.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.75,21.4,33.43,79.31V257.74l100.32-57.92Zm-4.26,176-91.8,53V81.77l91.8-53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.49 197.36 127.23 196.02 127.23 30.1 129.49 28.77 129.49 197.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.69 189.89 37.69 192.54 129.49 139.54 127.23 138.19 37.69 189.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.69 132.04 37.69 134.69 129.49 81.69 127.23 80.35 37.69 132.04",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.75 21.4 131.46 20.08 31.14 78 33.43 79.31 133.75 21.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.14 78 33.43 79.31 33.43 257.74 31.14 256.43 31.14 78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.04 58.48 80.33 57.16 80.33 225.75 78.04 224.44 78.04 58.48",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "84.59 54.71 80.33 57.16 80.33 225.75 84.59 223.28 84.59 54.71",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.75 79.23 133.75 84.15 33.43 142.06 33.43 137.15 133.75 79.23",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.75 137.07 133.75 141.99 33.43 199.9 33.43 194.99 133.75 137.07",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.33 110.07 78.04 108.75 37.69 132.04 37.69 134.69 80.33 110.07",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.33 167.9 78.04 166.57 37.69 189.87 37.69 192.51 80.33 167.9",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.79,408c-11.56-11.93-18.35-60.46-7.08-69.92h57.36c11.27,9.46,4.49,58-7.06,69.91l-.32.33-.39.39c-.33.32-.68.63-1,.94l-.27.22c-.29.22-.57.45-.88.66a14.54,14.54,0,0,1-1.49,1c-9.51,5.55-24.92,5.55-34.43,0h0a15.28,15.28,0,0,1-1.5-1c-.29-.2-.55-.41-.82-.62l-.34-.27c-.36-.3-.69-.6-1-.91l-.45-.45Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.79,408c-11.56-11.93-18.35-60.46-7.08-69.92h57.36c11.27,9.46,4.49,58-7.06,69.91l-.32.33-.39.39c-.33.32-.68.63-1,.94l-.27.22c-.29.22-.57.45-.88.66a14.54,14.54,0,0,1-1.49,1c-9.51,5.55-24.92,5.55-34.43,0h0a15.28,15.28,0,0,1-1.5-1c-.29-.2-.55-.41-.82-.62l-.34-.27c-.36-.3-.69-.6-1-.91l-.45-.45Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.09,334.27c13.09,7.64,13.09,20,0,27.67s-34.3,7.64-47.39,0-13.09-20,0-27.67S84,326.63,97.09,334.27Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.09,334.27c13.09,7.64,13.09,20,0,27.67s-34.3,7.64-47.39,0-13.09-20,0-27.67S84,326.63,97.09,334.27Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8,337.94c9.61,5.62,9.61,14.71,0,20.33s-25.2,5.61-34.81,0-9.61-14.71,0-20.33S81.19,332.33,90.8,337.94Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8,337.94c9.61,5.62,9.61,14.71,0,20.33s-25.2,5.61-34.81,0-9.61-14.71,0-20.33S81.19,332.33,90.8,337.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,347.59c9.61-5.61,25.2-5.61,34.81,0a15.94,15.94,0,0,1,5.75,5.34,16,16,0,0,1-5.75,5.34c-9.61,5.61-25.2,5.61-34.81,0a16,16,0,0,1-5.75-5.34A15.94,15.94,0,0,1,56,347.59Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.32,292.53c-2.13-3.85-6.06-6.81-3.41-15.47s3.61-21.12,6.08-23.63,6.27,5.14,7.73,14.18S90,288.47,79.32,292.53Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.79,263.94C57.71,263,47.35,255.87,48.68,240s12.93-39.33,19.71-39.1,5,12.88,4.32,29.57S71.11,252.75,60.79,263.94Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.77,278.69c-6,1.87-10.53.86-14.42-7.08s-4.85-17.79-2.75-19.15S43.92,260,46.52,263.7C50.46,269.33,52.25,270.73,52.77,278.69Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,314c-3.48-.73-5.41-1.25-7.15-6.5s-5.65-11.78-5.31-13.9,4.93.35,8.85,4.33S67,311.08,63.12,314Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.84,309.73c-4.9,0-7.85-.56-11.46-7.67s-4.85-20.16-1.9-21.85,5.51,4.18,9.63,11.46S46.82,301.64,43.84,309.73Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.82,321.92c-2.06,2-4.6,2.27-8.35-.09s-6.75-6.3-6.21-7.44,5.52,1,7.61,1.92C43,317.67,45.13,317.29,46.82,321.92Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.52,305.41c4.53-1.26,7.64-1.82,9.41-9.59s-.21-20.73-3.48-21.65-4.33,5.39-6.55,13.46S93.8,298.78,96.52,305.41Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.28,318.51c3.19,1.47,5.09,1.45,7.78-2.07s4.12-8.27,3.22-9.15-4.82,2.89-6.46,4.46C99.33,314.13,97.68,314.51,97.28,318.51Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,313.31c-1.92,1.07-3.53,2.68-5.41,3.84a39.32,39.32,0,0,1-5.13,2.52c-1.85.78-3.73,1.5-5.54,2.38-.51.25-1,.51-1.57.8,3.67-4.28,7.3-8.62,9.87-13.68a43.19,43.19,0,0,0,4-12.18,101.47,101.47,0,0,0,1-13.39c0-.2-.26-.44-.31-.14-.82,5.39-1.78,10.78-3.08,16.08a41.29,41.29,0,0,1-5,12.06A90,90,0,0,1,85,321.87c-2,2.37-4,4.88-5.91,7.38a41.66,41.66,0,0,0-4.24,6.39c-.13-2.62-.34-5.25-.66-7.86-.56-4.61-1.42-9.17-2.4-13.7a30.25,30.25,0,0,1,1.56-7.51,66.08,66.08,0,0,1,3.5-7.78c2.53-5,5-10,6.28-15.53a38.71,38.71,0,0,0,.78-4.8,43.14,43.14,0,0,0,.4-5.44c0-.14-.15-.08-.17,0-.26,1.42-.37,2.85-.68,4.27s-.73,3-1.13,4.43a70.29,70.29,0,0,1-2.9,8.38c-2.19,5.24-5.23,10.07-7.23,15.39a32.2,32.2,0,0,0-1.35,4.34q-.94-4.14-1.91-8.26c-3.94-17.16-7.67-34.54-8.15-52.21a145.08,145.08,0,0,1,.43-15.74c.19-2.37.41-4.75.73-7.11s.8-4.88,1.26-7.33c0-.13-.12-.21-.16-.06-.69,2.12-1.14,4.3-1.7,6.45a55,55,0,0,0-1.21,6.47,102.37,102.37,0,0,0-1,13.43,166.72,166.72,0,0,0,2,26.77c.85,5.62,1.92,11.2,3.08,16.77-.3-.42-.59-.83-.9-1.23a43.59,43.59,0,0,0-4.94-5.4c-3.29-3-7.11-5.32-10.6-8.09A17.67,17.67,0,0,1,42.54,268c-.06-.12-.16.06-.13.14,1.39,4,4.65,7.19,7.93,9.72,1.82,1.4,3.69,2.75,5.44,4.25a43.12,43.12,0,0,1,5.14,5.24c.91,1.09,1.77,2.23,2.57,3.41.37.54.72,1.1,1.07,1.66.2.32.37.61.57.87q.57,2.63,1.15,5.23c2,8.69,4.19,17.35,5.53,26.16.47,3.05.79,6.13,1,9.21A29.34,29.34,0,0,0,69.06,330l-.58-.48c-.31-.56-.71-1.11-.94-1.61a27.43,27.43,0,0,1-1.36-3.64c-.77-2.55-1.26-5.17-1.8-7.77-1-5-2.53-10.15-6.46-13.61-.05-.06-.12.09-.08.14,3.26,4,4.27,9.28,5.24,14.25a58.56,58.56,0,0,0,1.81,7.59,23.26,23.26,0,0,0,1,2.5c-2.24-1.77-4.56-3.44-6.87-5.11A89.68,89.68,0,0,1,49,314.16a41.31,41.31,0,0,1-7.74-10.49c-2.55-4.82-4.8-9.82-6.91-14.84-.12-.28-.32,0-.27.21a101.25,101.25,0,0,0,4.22,12.75,43.11,43.11,0,0,0,6.83,10.84c3.73,4.29,8.3,7.6,12.91,10.87-.59-.15-1.17-.28-1.73-.4-2-.42-4-.65-6-1a38.38,38.38,0,0,1-5.59-1.2c-2.1-.66-4.06-1.83-6.18-2.4-.12,0-.15.21-.08.26A27.77,27.77,0,0,0,50,323.38c1.84.33,3.7.55,5.54.91A59.77,59.77,0,0,1,61.4,326a.58.58,0,0,0,.18,0c1,.7,1.94,1.4,2.88,2.13a57.9,57.9,0,0,1,5.48,4.64,16.76,16.76,0,0,1,2.73,3.27c.11.18.2.36.3.54,0,.95.08,1.89.1,2.84.09,5.08-.34,10.1-.63,15.16-.06,1,1.55,1,1.7,0A84.92,84.92,0,0,0,75,341c0-.6,0-1.19,0-1.79,0-.2.1-.41.16-.61A17.42,17.42,0,0,1,77,334.79,61.28,61.28,0,0,1,81.17,329c.75-.93,1.51-1.85,2.28-2.77a.39.39,0,0,0,.17-.06A58.58,58.58,0,0,1,88.93,323c1.7-.79,3.45-1.46,5.15-2.23a27.85,27.85,0,0,0,10-7.24C104.16,313.47,104.06,313.25,104,313.31Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,313.31c-1.92,1.07-3.53,2.68-5.41,3.84a39.32,39.32,0,0,1-5.13,2.52c-1.85.78-3.73,1.5-5.54,2.38-.51.25-1,.51-1.57.8,3.67-4.28,7.3-8.62,9.87-13.68a43.19,43.19,0,0,0,4-12.18,101.47,101.47,0,0,0,1-13.39c0-.2-.26-.44-.31-.14-.82,5.39-1.78,10.78-3.08,16.08a41.29,41.29,0,0,1-5,12.06A90,90,0,0,1,85,321.87c-2,2.37-4,4.88-5.91,7.38a41.66,41.66,0,0,0-4.24,6.39c-.13-2.62-.34-5.25-.66-7.86-.56-4.61-1.42-9.17-2.4-13.7a30.25,30.25,0,0,1,1.56-7.51,66.08,66.08,0,0,1,3.5-7.78c2.53-5,5-10,6.28-15.53a38.71,38.71,0,0,0,.78-4.8,43.14,43.14,0,0,0,.4-5.44c0-.14-.15-.08-.17,0-.26,1.42-.37,2.85-.68,4.27s-.73,3-1.13,4.43a70.29,70.29,0,0,1-2.9,8.38c-2.19,5.24-5.23,10.07-7.23,15.39a32.2,32.2,0,0,0-1.35,4.34q-.94-4.14-1.91-8.26c-3.94-17.16-7.67-34.54-8.15-52.21a145.08,145.08,0,0,1,.43-15.74c.19-2.37.41-4.75.73-7.11s.8-4.88,1.26-7.33c0-.13-.12-.21-.16-.06-.69,2.12-1.14,4.3-1.7,6.45a55,55,0,0,0-1.21,6.47,102.37,102.37,0,0,0-1,13.43,166.72,166.72,0,0,0,2,26.77c.85,5.62,1.92,11.2,3.08,16.77-.3-.42-.59-.83-.9-1.23a43.59,43.59,0,0,0-4.94-5.4c-3.29-3-7.11-5.32-10.6-8.09A17.67,17.67,0,0,1,42.54,268c-.06-.12-.16.06-.13.14,1.39,4,4.65,7.19,7.93,9.72,1.82,1.4,3.69,2.75,5.44,4.25a43.12,43.12,0,0,1,5.14,5.24c.91,1.09,1.77,2.23,2.57,3.41.37.54.72,1.1,1.07,1.66.2.32.37.61.57.87q.57,2.63,1.15,5.23c2,8.69,4.19,17.35,5.53,26.16.47,3.05.79,6.13,1,9.21A29.34,29.34,0,0,0,69.06,330l-.58-.48c-.31-.56-.71-1.11-.94-1.61a27.43,27.43,0,0,1-1.36-3.64c-.77-2.55-1.26-5.17-1.8-7.77-1-5-2.53-10.15-6.46-13.61-.05-.06-.12.09-.08.14,3.26,4,4.27,9.28,5.24,14.25a58.56,58.56,0,0,0,1.81,7.59,23.26,23.26,0,0,0,1,2.5c-2.24-1.77-4.56-3.44-6.87-5.11A89.68,89.68,0,0,1,49,314.16a41.31,41.31,0,0,1-7.74-10.49c-2.55-4.82-4.8-9.82-6.91-14.84-.12-.28-.32,0-.27.21a101.25,101.25,0,0,0,4.22,12.75,43.11,43.11,0,0,0,6.83,10.84c3.73,4.29,8.3,7.6,12.91,10.87-.59-.15-1.17-.28-1.73-.4-2-.42-4-.65-6-1a38.38,38.38,0,0,1-5.59-1.2c-2.1-.66-4.06-1.83-6.18-2.4-.12,0-.15.21-.08.26A27.77,27.77,0,0,0,50,323.38c1.84.33,3.7.55,5.54.91A59.77,59.77,0,0,1,61.4,326a.58.58,0,0,0,.18,0c1,.7,1.94,1.4,2.88,2.13a57.9,57.9,0,0,1,5.48,4.64,16.76,16.76,0,0,1,2.73,3.27c.11.18.2.36.3.54,0,.95.08,1.89.1,2.84.09,5.08-.34,10.1-.63,15.16-.06,1,1.55,1,1.7,0A84.92,84.92,0,0,0,75,341c0-.6,0-1.19,0-1.79,0-.2.1-.41.16-.61A17.42,17.42,0,0,1,77,334.79,61.28,61.28,0,0,1,81.17,329c.75-.93,1.51-1.85,2.28-2.77a.39.39,0,0,0,.17-.06A58.58,58.58,0,0,1,88.93,323c1.7-.79,3.45-1.46,5.15-2.23a27.85,27.85,0,0,0,10-7.24C104.16,313.47,104.06,313.25,104,313.31Z",
    style: {
      opacity: 0.45
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.15,356.07V37.53c0-8.19-4.08-10.45-7.69-12.54s-9.57-3.35-14.71-.38L101.22,100.55c-5.14,3-9.3,10.18-9.3,16.11V435.2c0,5.93,3.72,9.43,7.33,11.51s9.92,4.38,15.06,1.42l131.53-75.95A17.49,17.49,0,0,0,255.15,356.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.78,359.09,111.52,437.18l0-319.92-16.92-9.77a19.05,19.05,0,0,0-2.72,9.17V435.2c0,5.93,3.72,9.43,7.33,11.51s9.92,4.38,15.06,1.42l131.53-75.95a17.72,17.72,0,0,0,8.06-9l-.53-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.6,34.78,113.69,111a14.45,14.45,0,0,0-6.54,11.3V438.19c0,6.37,4.53,9,10,5.79l128.4-74.13A16.4,16.4,0,0,0,253,357v-318C253,34.35,249.67,32.43,245.6,34.78Z",
    style: {
      fill: "#455a64"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.56,54.15V349.49a15.6,15.6,0,0,1-7,12.19L120.62,430.34c-3.88,2.25-7,.44-7-4V128.78a15.73,15.73,0,0,1,4.93-10.6l.67-.6a10.91,10.91,0,0,1,1.43-1l33.45-19.32s1-.57,2.18-1.25,2.18-.14,2.18,1.25,1,1.92,2.33,1.17l39-22.5a5,5,0,0,0,2.33-3.86,4.94,4.94,0,0,1,2-3.65l.23-.14L237,49.43l.7-.41C242.57,46.19,246.56,48.5,246.56,54.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,353.79a15.54,15.54,0,0,0,7-12.18V49.78l-32.1,18.53-.23.14a4.94,4.94,0,0,0-2,3.65A5,5,0,0,1,199.74,76l-39,22.5c-1.29.75-2.33.22-2.33-1.17s-1-2-2.18-1.25-2.18,1.25-2.18,1.25l-33.45,19.32a10.91,10.91,0,0,0-1.43,1l-.67.6a15.73,15.73,0,0,0-4.93,10.6V420.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.68,86.58l17.87-10.32c1.06-.62,1.93-.18,1.93,1a4.16,4.16,0,0,1-1.93,3.21L166.68,90.76c-1.07.61-1.93.18-1.93-1A4.12,4.12,0,0,1,166.68,86.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.71,70.12c1.21-.7,2.18-.13,2.18,1.25a4.78,4.78,0,0,1-2.18,3.77c-1.2.69-2.17.13-2.17-1.26A4.8,4.8,0,0,1,193.71,70.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.12,154.87a7.85,7.85,0,0,0-3.44-6.21,2.28,2.28,0,0,0-2.36-.2c-.43.26-2.12,1.21-2.57,1.48a2.68,2.68,0,0,0-1.07,2.44v26a7.85,7.85,0,0,0,3.44,6.22,2.3,2.3,0,0,0,2.27.24c.48-.25,2.21-1.25,2.66-1.52a2.68,2.68,0,0,0,1.07-2.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.56,156.35v26c0,2.34-1.54,3.35-3.44,2.25a7.85,7.85,0,0,1-3.44-6.22v-26c0-2.34,1.54-3.34,3.44-2.25A7.86,7.86,0,0,1,101.56,156.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.12,200.3a7.86,7.86,0,0,0-3.44-6.22,2.3,2.3,0,0,0-2.36-.19c-.43.26-2.12,1.21-2.57,1.48a2.68,2.68,0,0,0-1.07,2.44v25.95A7.86,7.86,0,0,0,98.12,230a2.33,2.33,0,0,0,2.27.24c.48-.25,2.21-1.25,2.66-1.52a2.68,2.68,0,0,0,1.07-2.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.56,201.78v25.95c0,2.34-1.54,3.35-3.44,2.25a7.86,7.86,0,0,1-3.44-6.22V197.81c0-2.34,1.54-3.35,3.44-2.25A7.86,7.86,0,0,1,101.56,201.78Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.53,64.09c-1.63-.94-3.88-.81-6.36.62l-.71.42L229.25,84.3a1.42,1.42,0,0,0-.23.14,5,5,0,0,0-2,3.71,5.08,5.08,0,0,1-2.37,3.91L185.1,114.9l-.09,0a1.53,1.53,0,0,0-.64-1.35l-2.29-1.32a1.56,1.56,0,0,0-1.56.16l-2.21,1.28-34,19.6a13.3,13.3,0,0,0-1.45,1l-.68.61a16,16,0,0,0-5,10.76v302c0,2.27.8,3.86,2.08,4.6l2.3,1.33c1.29.75,3.07.64,5-.5l120.72-69.7a15.82,15.82,0,0,0,7.13-12.37V71.24c0-2.86-1-4.87-2.64-5.82Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.31,452.14v.59l-.68.39c-2,1.14-3.74,1.25-5,.51l-2.3-1.33c-1.29-.75-2.08-2.34-2.08-4.61v-302a14.85,14.85,0,0,1,2.46-7.62l2.72,1.57A14.45,14.45,0,0,0,140,147V449a5.52,5.52,0,0,0,1,3.44,3,3,0,0,0,2.45,1.15,6,6,0,0,0,2.94-.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.66,87.15a4.21,4.21,0,0,0-.83,2.32,5.07,5.07,0,0,1-.88,2.64l-2.74-1.58a4.53,4.53,0,0,0,.83-2.38,4.83,4.83,0,0,1,.89-2.58Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.44,453.59a3,3,0,0,1-2.44-1.14,5.46,5.46,0,0,1-1-3.44V147a15.49,15.49,0,0,1,4.85-10.39l.21-.19.45-.4a10.45,10.45,0,0,1,1.37-.94l34-19.61,2.21-1.27a1.49,1.49,0,0,1,.74-.24c.64,0,.71.75.71,1.07a1.82,1.82,0,0,0,1.76,2,2.68,2.68,0,0,0,1.37-.42l39.57-22.84a5.56,5.56,0,0,0,2.62-4.36,4.51,4.51,0,0,1,1.77-3.29l.19-.11L265,66.89l.72-.42a7.69,7.69,0,0,1,3.76-1.16c2.77,0,4.5,2.28,4.5,5.93V371.05A15.19,15.19,0,0,1,267.1,383l-120.72,69.7A6,6,0,0,1,143.44,453.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.48,65.82h0c2.5,0,4,2,4,5.42V371.05a14.89,14.89,0,0,1-6.62,11.49l-120.72,69.7a5.59,5.59,0,0,1-2.69.85c-1.83,0-2.92-1.53-2.92-4.08V147a15,15,0,0,1,4.67-10l.23-.22.4-.35a11.18,11.18,0,0,1,1.32-.91l34-19.61,2.22-1.27a1,1,0,0,1,.48-.17c.2,0,.2.51.2.56a2.32,2.32,0,0,0,2.27,2.55,3.18,3.18,0,0,0,1.62-.48l39.58-22.84a6.12,6.12,0,0,0,2.87-4.8,4,4,0,0,1,1.56-2.88l.14-.09,33.22-19.17.71-.41a7.22,7.22,0,0,1,3.51-1.09m0-1a8.14,8.14,0,0,0-4,1.22l-.71.42L231.54,85.62a1.09,1.09,0,0,0-.23.14,5,5,0,0,0-2,3.7A5.1,5.1,0,0,1,227,93.38l-39.57,22.84a2.26,2.26,0,0,1-1.12.35c-.74,0-1.25-.56-1.25-1.54s-.5-1.58-1.22-1.58a2,2,0,0,0-1,.31L180.59,115l-34,19.61a12,12,0,0,0-1.45,1l-.68.61a16,16,0,0,0-5,10.75V449c0,3.22,1.6,5.09,3.93,5.09a6.55,6.55,0,0,0,3.2-1l120.72-69.7a15.82,15.82,0,0,0,7.13-12.37V71.24c0-4.07-2.05-6.43-5-6.43Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.19,152.4a1,1,0,0,1-.56-.19l-2.7-2a1,1,0,0,1-.27-1.18l2.7-5.15a.93.93,0,1,1,1.65.86l-2.33,4.46,2.07,1.56a.94.94,0,0,1,.18,1.31A.93.93,0,0,1,152.19,152.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.93,90.28a3.59,3.59,0,0,1-1.49,2.85c-.82.47-1.49,0-1.49-1.13a3.59,3.59,0,0,1,1.49-2.85C251.26,88.68,251.93,89.18,251.93,90.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.22,86.65a3.59,3.59,0,0,1-1.49,2.85c-.83.47-1.49,0-1.49-1.13a3.52,3.52,0,0,1,1.49-2.84C257.55,85.05,258.22,85.55,258.22,86.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5,83A3.59,3.59,0,0,1,263,85.87c-.82.47-1.49,0-1.49-1.13A3.57,3.57,0,0,1,263,81.9C263.83,81.42,264.5,81.93,264.5,83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,161.64a7.23,7.23,0,0,1-3.63-.95c-3.07-1.77-4.83-5.84-4.83-11.17,0-10,6.09-21.58,13.58-25.9,3.35-1.94,6.6-2.19,9.16-.71,3.06,1.77,4.82,5.84,4.82,11.17,0,10-6.09,21.58-13.58,25.9A11.14,11.14,0,0,1,201.2,161.64Zm10.64-38.87a10.43,10.43,0,0,0-5.12,1.54c-7.26,4.2-13.17,15.51-13.17,25.21,0,5,1.61,8.85,4.42,10.47,2.3,1.33,5.26,1.08,8.35-.7,7.26-4.2,13.17-15.51,13.17-25.21,0-5-1.61-8.85-4.42-10.47A6.38,6.38,0,0,0,211.84,122.77Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.21,161.65a7.1,7.1,0,0,1-4.29-1.39.4.4,0,0,1-.17-.36l.05-.55c.4-5.23,3.56-10.82,7.35-13l4.34-2.5a5.06,5.06,0,0,1,5-.46c1.59.82,2.58,2.67,2.8,5.2l0,.5a.45.45,0,0,1,0,.23c-2.56,4.81-5.94,8.6-9.53,10.67h0A11.11,11.11,0,0,1,201.21,161.65Zm-3.64-1.91c2.36,1.6,5.46,1.45,8.75-.45h0c3.43-2,6.68-5.63,9.16-10.26l0-.39c-.19-2.24-1-3.86-2.36-4.55a4.34,4.34,0,0,0-4.19.44L204.55,147c-3.57,2.06-6.56,7.38-7,12.37Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.34,144.19a3.11,3.11,0,0,1-1.61-.43c-1.34-.77-2.1-2.51-2.1-4.79,0-4.16,2.55-9,5.69-10.84a3.92,3.92,0,0,1,4-.29c1.33.77,2.1,2.52,2.1,4.79,0,4.17-2.56,9-5.7,10.84A4.76,4.76,0,0,1,204.34,144.19Zm4.36-16a4,4,0,0,0-2,.6c-2.91,1.68-5.29,6.24-5.29,10.14,0,2,.62,3.47,1.7,4.1a3.17,3.17,0,0,0,3.19-.29c2.92-1.69,5.29-6.24,5.29-10.15,0-2-.62-3.47-1.7-4.09A2.37,2.37,0,0,0,208.7,128.23Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,175a3.54,3.54,0,0,1,1.39-.52,1.88,1.88,0,0,1,1,.12,1.34,1.34,0,0,1,.61.59,2,2,0,0,1,.23.84.61.61,0,0,1-.09.36.7.7,0,0,1-.23.25l-.83.48c-.13.07-.23.1-.3.07a.42.42,0,0,1-.18-.17.83.83,0,0,0-.54-.38A1.66,1.66,0,0,0,191,177a3.33,3.33,0,0,0-1.07,1,2.67,2.67,0,0,0-.33.59,1.68,1.68,0,0,0-.11.61.89.89,0,0,0,.11.52.45.45,0,0,0,.38.18,2.28,2.28,0,0,0,.7-.1l1.09-.3a5.37,5.37,0,0,1,1.22-.22,1.38,1.38,0,0,1,.84.18,1.11,1.11,0,0,1,.48.61,2.83,2.83,0,0,1,.16,1.05,4.73,4.73,0,0,1-.23,1.46,6.44,6.44,0,0,1-.68,1.43,7.53,7.53,0,0,1-1.07,1.3,6.89,6.89,0,0,1-1.43,1.08,4.43,4.43,0,0,1-1.27.52,2.15,2.15,0,0,1-1.07,0,1.34,1.34,0,0,1-.75-.53,2.09,2.09,0,0,1-.32-1.08.8.8,0,0,1,.09-.36.71.71,0,0,1,.23-.25l.83-.48a.42.42,0,0,1,.31-.08.28.28,0,0,1,.17.18,1.94,1.94,0,0,0,.21.29.54.54,0,0,0,.31.18,1.14,1.14,0,0,0,.51,0,3.18,3.18,0,0,0,.75-.33,5.91,5.91,0,0,0,.68-.47,3.14,3.14,0,0,0,.58-.57,2.73,2.73,0,0,0,.4-.64,1.52,1.52,0,0,0,.16-.69.59.59,0,0,0-.17-.48.69.69,0,0,0-.5-.08,4.34,4.34,0,0,0-.83.18l-1.15.3a3.76,3.76,0,0,1-1,.14,1.24,1.24,0,0,1-.74-.21,1.27,1.27,0,0,1-.43-.64,3.93,3.93,0,0,1-.14-1.14,4.68,4.68,0,0,1,.24-1.45,5.92,5.92,0,0,1,.65-1.4,6.7,6.7,0,0,1,1-1.23A5.82,5.82,0,0,1,191,175Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,171.52a.21.21,0,0,1,.23,0,.3.3,0,0,1,.09.25V173a.79.79,0,0,1-.09.35.66.66,0,0,1-.23.26l-1,.58a.2.2,0,0,1-.23,0,.3.3,0,0,1-.09-.25v-1.23a.79.79,0,0,1,.09-.35.59.59,0,0,1,.23-.26Zm.26,10.61a.8.8,0,0,1-.09.36.56.56,0,0,1-.23.25l-.9.52a.18.18,0,0,1-.22,0,.27.27,0,0,1-.1-.24v-7.34a.81.81,0,0,1,.1-.36.72.72,0,0,1,.22-.26l.9-.51a.2.2,0,0,1,.23,0,.3.3,0,0,1,.09.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.58,181.64a2.35,2.35,0,0,0,.5-.39,3.24,3.24,0,0,0,.48-.6,4.08,4.08,0,0,0,.35-.76A2.82,2.82,0,0,0,203,179v-.59a3.62,3.62,0,0,1-.25.45,3.34,3.34,0,0,1-.37.52,5.06,5.06,0,0,1-.51.54,4,4,0,0,1-.65.47,1.92,1.92,0,0,1-1.07.31,1.3,1.3,0,0,1-.82-.35,2.15,2.15,0,0,1-.53-.88,4.36,4.36,0,0,1-.22-1.26c0-.16,0-.34,0-.55s0-.39,0-.56a7.54,7.54,0,0,1,.22-1.52,8.23,8.23,0,0,1,.53-1.49,6.57,6.57,0,0,1,.82-1.29,3.86,3.86,0,0,1,1.07-.92,2.72,2.72,0,0,1,.65-.29,1.6,1.6,0,0,1,.51-.05,1,1,0,0,1,.37.09.83.83,0,0,1,.25.16v-.36a.67.67,0,0,1,.1-.35.58.58,0,0,1,.22-.26l.9-.52a.18.18,0,0,1,.22,0,.27.27,0,0,1,.1.24V178a6.73,6.73,0,0,1-.8,3.33,5.78,5.78,0,0,1-2.2,2.24,3.4,3.4,0,0,1-1.12.44,1.73,1.73,0,0,1-.89-.06,1.21,1.21,0,0,1-.61-.45,1.47,1.47,0,0,1-.25-.78.79.79,0,0,1,.09-.35.75.75,0,0,1,.23-.26l.81-.46a.24.24,0,0,1,.28,0,2,2,0,0,1,.2.16.58.58,0,0,0,.42.2A1.76,1.76,0,0,0,201.58,181.64Zm-1.42-5.29a4.31,4.31,0,0,0,0,.88c0,.66.2,1.06.47,1.2a1,1,0,0,0,1-.12,2.68,2.68,0,0,0,1-1,3.6,3.6,0,0,0,.45-1.57,5.54,5.54,0,0,0,0-.61,5,5,0,0,0,0-.59,1.27,1.27,0,0,0-.45-1,.94.94,0,0,0-1,.09,2.75,2.75,0,0,0-1,1A3.81,3.81,0,0,0,200.16,176.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,173.64a.69.69,0,0,1-.1.35.5.5,0,0,1-.22.25l-.9.52a.2.2,0,0,1-.22,0,.28.28,0,0,1-.1-.25v-4a2,2,0,0,0-.33-1.32c-.22-.25-.56-.25-1,0a2.49,2.49,0,0,0-1,1.13,4.06,4.06,0,0,0-.36,1.73v4a.81.81,0,0,1-.1.35.65.65,0,0,1-.22.26l-.9.52a.19.19,0,0,1-.23,0,.3.3,0,0,1-.09-.24v-7.35a.79.79,0,0,1,.09-.35.66.66,0,0,1,.23-.26l.9-.52a.18.18,0,0,1,.22,0,.3.3,0,0,1,.1.24v.37a6.13,6.13,0,0,1,.72-1.1,3.41,3.41,0,0,1,1-.83,2.37,2.37,0,0,1,1.2-.4,1.07,1.07,0,0,1,.79.36,2,2,0,0,1,.41.93,6.09,6.09,0,0,1,.13,1.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.52,159.67a.19.19,0,0,1,.23,0,.3.3,0,0,1,.09.24v1.23a.8.8,0,0,1-.09.36.63.63,0,0,1-.23.25l-1,.59a.19.19,0,0,1-.23,0,.3.3,0,0,1-.09-.24v-1.23a.8.8,0,0,1,.09-.36.56.56,0,0,1,.23-.25Zm.26,10.61a.8.8,0,0,1-.09.36.63.63,0,0,1-.23.25l-.9.52a.2.2,0,0,1-.22,0,.3.3,0,0,1-.09-.25v-7.34a.8.8,0,0,1,.09-.36.61.61,0,0,1,.22-.25l.9-.52a.19.19,0,0,1,.23,0,.27.27,0,0,1,.09.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.18,166a.8.8,0,0,1-.09.36.63.63,0,0,1-.23.25l-.9.52a.18.18,0,0,1-.22,0,.27.27,0,0,1-.1-.24v-4a2.07,2.07,0,0,0-.33-1.33c-.22-.25-.56-.24-1,0a2.48,2.48,0,0,0-1,1.14,4,4,0,0,0-.36,1.72v4a.79.79,0,0,1-.09.35.57.57,0,0,1-.23.25l-.9.52a.18.18,0,0,1-.22,0,.28.28,0,0,1-.1-.25V162a.7.7,0,0,1,.1-.36.61.61,0,0,1,.22-.25l.9-.52a.19.19,0,0,1,.23,0,.28.28,0,0,1,.09.24v.36a7.34,7.34,0,0,1,.72-1.09,3.39,3.39,0,0,1,1-.83,2.37,2.37,0,0,1,1.21-.4,1.06,1.06,0,0,1,.78.35,2.06,2.06,0,0,1,.42.93,6.88,6.88,0,0,1,.12,1.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.29,230.71a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.16v.36a.49.49,0,0,1-.06.22.38.38,0,0,1-.14.16l-3,1.75a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-6.46a.49.49,0,0,1,.06-.22.38.38,0,0,1,.14-.16l3-1.71a.12.12,0,0,1,.14,0,.2.2,0,0,1,.06.16v.36a.46.46,0,0,1-.06.22.38.38,0,0,1-.14.16L156.77,227v2.11l2.29-1.32q.09-.06.15,0a.18.18,0,0,1,.06.15v.36a.46.46,0,0,1-.06.22.42.42,0,0,1-.15.17L156.77,230v2.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.44,228.38a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-.32a.49.49,0,0,1,.06-.23.45.45,0,0,1,.14-.16l2.21-1.27c.06,0,.1,0,.14,0a.18.18,0,0,1,.06.16v.32a.46.46,0,0,1-.06.22.32.32,0,0,1-.14.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.61,223.93a3.23,3.23,0,0,1,.15-.34,2.39,2.39,0,0,1,.21-.34,3.74,3.74,0,0,1,.27-.31,2.07,2.07,0,0,1,.37-.27,1.13,1.13,0,0,1,.76-.21.66.66,0,0,1,.47.37c.06-.16.13-.31.2-.46a3.78,3.78,0,0,1,.26-.43,2.91,2.91,0,0,1,.33-.37,2.07,2.07,0,0,1,.43-.31c.5-.3.87-.31,1.1,0a2.31,2.31,0,0,1,.35,1.46v2.76a.51.51,0,0,1-.07.23.32.32,0,0,1-.14.16L169,226a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-2.67a1.52,1.52,0,0,0-.22-1c-.15-.16-.37-.15-.66,0a1.74,1.74,0,0,0-.64.72,2.79,2.79,0,0,0-.24,1.22v2.74a.6.6,0,0,1-.06.22.39.39,0,0,1-.15.16l-.27.16a.12.12,0,0,1-.15,0,.2.2,0,0,1-.06-.16v-2.66a1.56,1.56,0,0,0-.22-1c-.15-.15-.37-.15-.66,0a1.62,1.62,0,0,0-.64.72,2.73,2.73,0,0,0-.24,1.22v2.73a.49.49,0,0,1-.06.23.39.39,0,0,1-.15.16l-.27.16a.14.14,0,0,1-.15,0,.17.17,0,0,1,0-.15V224a.44.44,0,0,1,0-.22.34.34,0,0,1,.15-.16l.27-.16a.12.12,0,0,1,.15,0,.2.2,0,0,1,.06.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.31,223.94a2.48,2.48,0,0,1,.12-.77,3,3,0,0,1,.33-.7,3.61,3.61,0,0,1,.49-.62,6.2,6.2,0,0,1,.6-.55l1.05-.83v-.13c0-.34-.08-.55-.25-.62a.67.67,0,0,0-.62.1,1.47,1.47,0,0,0-.5.45,3.19,3.19,0,0,0-.29.55.49.49,0,0,1-.1.16.4.4,0,0,1-.14.11l-.22.13a.12.12,0,0,1-.15,0,.18.18,0,0,1-.06-.16,2.46,2.46,0,0,1,.13-.52A3.09,3.09,0,0,1,171,220a3,3,0,0,1,.46-.56A2.53,2.53,0,0,1,172,219a1.76,1.76,0,0,1,.62-.23.74.74,0,0,1,.5.1.87.87,0,0,1,.32.43,2.13,2.13,0,0,1,.12.78v3.05a.46.46,0,0,1-.06.22.34.34,0,0,1-.15.16l-.27.16a.12.12,0,0,1-.15,0,.2.2,0,0,1-.06-.16v-.41a1.57,1.57,0,0,1-.21.46,3.19,3.19,0,0,1-.32.43,3.3,3.3,0,0,1-.38.37,2.35,2.35,0,0,1-.38.26,1.3,1.3,0,0,1-.53.2.68.68,0,0,1-.41,0,.6.6,0,0,1-.26-.3A1.06,1.06,0,0,1,170.31,223.94Zm1.38-.25a2.26,2.26,0,0,0,.5-.39,2.85,2.85,0,0,0,.38-.53,2.52,2.52,0,0,0,.25-.61,2.36,2.36,0,0,0,.08-.65v-.25l-.88.7a4.12,4.12,0,0,0-.75.76,1.26,1.26,0,0,0-.28.73.58.58,0,0,0,0,.19.33.33,0,0,0,.12.14.3.3,0,0,0,.21,0A.83.83,0,0,0,171.69,223.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.44,216a.46.46,0,0,1-.06.22.42.42,0,0,1-.15.17l-.42.24a.14.14,0,0,1-.15,0,.17.17,0,0,1,0-.15V216a.5.5,0,0,1,0-.23.39.39,0,0,1,.15-.16l.42-.24c.06,0,.11,0,.15,0a.2.2,0,0,1,.06.16Zm-.08,6a.49.49,0,0,1-.06.23.45.45,0,0,1-.14.16l-.28.16a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15V217.8a.46.46,0,0,1,.06-.22.38.38,0,0,1,.14-.16l.28-.16a.1.1,0,0,1,.14,0,.18.18,0,0,1,.06.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.17,221a.71.71,0,0,1-.06.23.39.39,0,0,1-.15.16l-.27.16a.14.14,0,0,1-.15,0,.18.18,0,0,1-.06-.16v-6.55a.49.49,0,0,1,.06-.22.34.34,0,0,1,.15-.16l.27-.16a.14.14,0,0,1,.15,0,.21.21,0,0,1,.06.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.6,245.46l.16-.34a3.79,3.79,0,0,1,.2-.34,2,2,0,0,1,.28-.31,1.54,1.54,0,0,1,.37-.27,1.11,1.11,0,0,1,.75-.21.62.62,0,0,1,.47.37l.21-.46a3.7,3.7,0,0,1,.25-.43,2.91,2.91,0,0,1,.33-.37,2.83,2.83,0,0,1,.43-.32c.51-.29.88-.3,1.1,0a2.31,2.31,0,0,1,.35,1.46V247a.49.49,0,0,1-.06.23.45.45,0,0,1-.14.16l-.28.16a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15V244.7a1.51,1.51,0,0,0-.23-1c-.15-.16-.37-.15-.65,0a1.59,1.59,0,0,0-.65.72,2.76,2.76,0,0,0-.24,1.22v2.74a.49.49,0,0,1-.06.22.38.38,0,0,1-.14.16l-.28.16s-.1,0-.14,0a.18.18,0,0,1-.06-.15v-2.67a1.53,1.53,0,0,0-.23-1c-.15-.16-.37-.15-.65,0a1.59,1.59,0,0,0-.64.71,2.65,2.65,0,0,0-.25,1.22v2.74a.46.46,0,0,1-.06.22.49.49,0,0,1-.14.17l-.28.16a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.16v-4.65a.46.46,0,0,1,.06-.22.49.49,0,0,1,.14-.17l.28-.16a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.6,247.69a1,1,0,0,1-.08.2.28.28,0,0,1-.14.16l-.31.18a.1.1,0,0,1-.13,0,.17.17,0,0,1-.05-.14s0-.05,0-.07l.72-2.5L167.14,242a.13.13,0,0,1,0-.06.54.54,0,0,1,.05-.21.44.44,0,0,1,.13-.14l.3-.18c.07,0,.11,0,.15,0a.29.29,0,0,1,.07.12l1.16,2.73,1.16-4.07a1,1,0,0,1,.08-.2.34.34,0,0,1,.14-.17l.31-.17a.12.12,0,0,1,.13,0,.2.2,0,0,1,.05.14.22.22,0,0,1,0,.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.08,242a.49.49,0,0,1-.06.22.32.32,0,0,1-.14.16l-.28.16s-.1,0-.14,0a.16.16,0,0,1-.06-.15v-2.64c0-.51-.09-.84-.28-1s-.44-.13-.77.06a2,2,0,0,0-.76.82,2.79,2.79,0,0,0-.29,1.31v2.64a.46.46,0,0,1-.06.22.4.4,0,0,1-.14.17l-.28.16a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.16v-4.65a.46.46,0,0,1,.06-.22.49.49,0,0,1,.14-.17l.28-.16a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.16v.31a3.73,3.73,0,0,1,.43-.71,2.28,2.28,0,0,1,.73-.64,1.47,1.47,0,0,1,.66-.22.69.69,0,0,1,.51.14,1.08,1.08,0,0,1,.33.51,2.73,2.73,0,0,1,.12.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.89,240.51a2.48,2.48,0,0,1,.12-.77,3.19,3.19,0,0,1,.33-.7,4,4,0,0,1,.49-.62,7.7,7.7,0,0,1,.6-.54l1-.84v-.13c0-.34-.08-.55-.25-.62a.68.68,0,0,0-.62.11,1.36,1.36,0,0,0-.5.44,3.6,3.6,0,0,0-.29.55.49.49,0,0,1-.1.16.58.58,0,0,1-.14.12l-.22.13a.14.14,0,0,1-.15,0,.18.18,0,0,1-.06-.16,2.07,2.07,0,0,1,.13-.52,3.09,3.09,0,0,1,.32-.59,3.42,3.42,0,0,1,.46-.56,2.22,2.22,0,0,1,.55-.43,1.79,1.79,0,0,1,.62-.24.76.76,0,0,1,.5.1.92.92,0,0,1,.32.43,2.19,2.19,0,0,1,.11.78v3a.59.59,0,0,1,0,.22.51.51,0,0,1-.15.17l-.27.16a.14.14,0,0,1-.15,0,.18.18,0,0,1-.06-.16v-.41a1.46,1.46,0,0,1-.21.46,2.67,2.67,0,0,1-.32.43,3.3,3.3,0,0,1-.38.37,3.44,3.44,0,0,1-.38.27,1.46,1.46,0,0,1-.53.2.68.68,0,0,1-.41-.06A.64.64,0,0,1,176,241,1.29,1.29,0,0,1,175.89,240.51Zm1.38-.25a2,2,0,0,0,.49-.39,2.9,2.9,0,0,0,.39-.53,2.52,2.52,0,0,0,.25-.61,2.8,2.8,0,0,0,.08-.64v-.25l-.88.7a3.54,3.54,0,0,0-.75.75,1.29,1.29,0,0,0-.28.73.65.65,0,0,0,0,.2.39.39,0,0,0,.12.14.35.35,0,0,0,.21,0A.83.83,0,0,0,177.27,240.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.94,234.29a3.29,3.29,0,0,1,.16-.33,1.9,1.9,0,0,1,.2-.34,2.67,2.67,0,0,1,.28-.32,1.69,1.69,0,0,1,.36-.27,1.27,1.27,0,0,1,.76-.21.66.66,0,0,1,.47.37c.07-.15.13-.31.21-.46a2.58,2.58,0,0,1,.25-.42,3,3,0,0,1,.33-.38,2.37,2.37,0,0,1,.43-.31c.51-.29.87-.3,1.1,0a2.27,2.27,0,0,1,.35,1.45v2.77a.46.46,0,0,1-.06.22.34.34,0,0,1-.15.16l-.27.16c-.06,0-.1,0-.14,0a.2.2,0,0,1-.06-.16v-2.66a1.54,1.54,0,0,0-.23-1c-.15-.16-.37-.15-.66,0a1.62,1.62,0,0,0-.64.72,2.72,2.72,0,0,0-.24,1.21v2.74a.49.49,0,0,1-.06.23.45.45,0,0,1-.14.16l-.28.16a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15V235a1.51,1.51,0,0,0-.23-1c-.15-.16-.37-.16-.66,0a1.69,1.69,0,0,0-.64.72,2.76,2.76,0,0,0-.24,1.22v2.74a.49.49,0,0,1-.06.22.38.38,0,0,1-.14.16l-.28.16c-.06,0-.1,0-.14,0a.18.18,0,0,1-.06-.15v-4.65a.49.49,0,0,1,.06-.23.32.32,0,0,1,.14-.16l.28-.16a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,232.46a4.41,4.41,0,0,1,.17-1,4.76,4.76,0,0,1,.35-.91,3.72,3.72,0,0,1,.52-.77,2.78,2.78,0,0,1,.68-.56,1.69,1.69,0,0,1,.72-.24.75.75,0,0,1,.54.19,1.24,1.24,0,0,1,.35.6,3.45,3.45,0,0,1,.12,1v.27a.46.46,0,0,1-.06.22.49.49,0,0,1-.14.17l-2.58,1.48V233c0,.45.11.74.31.87a.68.68,0,0,0,.74-.07,1.91,1.91,0,0,0,.62-.51,4.53,4.53,0,0,0,.33-.53.75.75,0,0,1,.1-.17.4.4,0,0,1,.14-.11l.22-.13c.06,0,.11,0,.15,0a.14.14,0,0,1,.06.16,2.26,2.26,0,0,1-.13.47,2.7,2.7,0,0,1-.31.57,3.69,3.69,0,0,1-.49.6,3.29,3.29,0,0,1-.69.52,1.35,1.35,0,0,1-.68.22.8.8,0,0,1-.52-.18,1.32,1.32,0,0,1-.35-.51,2.7,2.7,0,0,1-.17-.81A7.06,7.06,0,0,1,186.74,232.46Zm.67-.36,2.1-1.21v0a.93.93,0,0,0-.28-.81.72.72,0,0,0-.77.08,1.57,1.57,0,0,0-.41.33,2.71,2.71,0,0,0-.33.46,2.43,2.43,0,0,0-.22.55,2.49,2.49,0,0,0-.09.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.46,227.71a3.2,3.2,0,0,1-.11.72,2.81,2.81,0,0,1-.24.58,2,2,0,0,1-.34.46,2,2,0,0,1-.41.32,1,1,0,0,1-.55.18.5.5,0,0,1-.33-.13l-.12.27a3,3,0,0,1-.17.28,3.2,3.2,0,0,1-.26.28,2.42,2.42,0,0,1-.41.28.85.85,0,0,1-.53.15.54.54,0,0,1-.38-.22,1.32,1.32,0,0,1-.23-.52,3.26,3.26,0,0,1-.07-.74,4.57,4.57,0,0,1,.07-.83,3.73,3.73,0,0,1,.23-.78,2.7,2.7,0,0,1,.38-.66,1.81,1.81,0,0,1,.53-.47.72.72,0,0,1,.49-.14.71.71,0,0,1,.26.14v-.09a.53.53,0,0,1,.06-.23.45.45,0,0,1,.14-.16l.24-.14a.14.14,0,0,1,.15,0,.22.22,0,0,1,.06.16v2.12a.63.63,0,0,0,.11.44q.12.12.33,0a.69.69,0,0,0,.22-.19.89.89,0,0,0,.14-.25,1.38,1.38,0,0,0,.08-.27,1.21,1.21,0,0,0,0-.25c0-.08,0-.24,0-.47a6.26,6.26,0,0,0,0-.74c-.06-.77-.27-1.25-.64-1.42a1.74,1.74,0,0,0-1.54.31,3.65,3.65,0,0,0-.73.56,4.72,4.72,0,0,0-.63.81,5.07,5.07,0,0,0-.45,1,4.94,4.94,0,0,0-.23,1.18c0,.09,0,.2,0,.35s0,.3,0,.45,0,.31,0,.46,0,.26,0,.35a2.36,2.36,0,0,0,.23.9,1.08,1.08,0,0,0,.45.47,1,1,0,0,0,.63.07,2,2,0,0,0,.73-.27,5.49,5.49,0,0,0,.53-.34,3.37,3.37,0,0,0,.39-.33,2.45,2.45,0,0,0,.31-.34c.09-.13.19-.26.28-.4l.13-.18a.3.3,0,0,1,.13-.12l.33-.19a.14.14,0,0,1,.14,0c.05,0,.06.09.06.17a.41.41,0,0,1-.05.18c-.11.2-.23.41-.37.62a4.33,4.33,0,0,1-.47.61,5.86,5.86,0,0,1-.62.59,5.45,5.45,0,0,1-.79.54,2.76,2.76,0,0,1-1,.36,1.34,1.34,0,0,1-1.43-.75,2.82,2.82,0,0,1-.28-1.16c0-.09,0-.22,0-.37s0-.32,0-.49,0-.33,0-.48,0-.28,0-.37a5.69,5.69,0,0,1,.27-1.47,5.86,5.86,0,0,1,.6-1.32,6.1,6.1,0,0,1,.83-1.1,4.66,4.66,0,0,1,1-.78,3.39,3.39,0,0,1,1.13-.44,1.31,1.31,0,0,1,.87.1,1.19,1.19,0,0,1,.57.65,3.35,3.35,0,0,1,.25,1.19c0,.13,0,.26,0,.4v.39c0,.12,0,.23,0,.32Zm-3.52,1.54a2.58,2.58,0,0,0,0,.4,1,1,0,0,0,.11.33.38.38,0,0,0,.2.18.35.35,0,0,0,.31-.07,1.1,1.1,0,0,0,.53-.63,3.12,3.12,0,0,0,.14-1,3.58,3.58,0,0,0,0-.49.86.86,0,0,0-.11-.32.28.28,0,0,0-.2-.14.54.54,0,0,0-.33.1,1,1,0,0,0-.31.29,2,2,0,0,0-.2.41,2.47,2.47,0,0,0-.11.47A3.75,3.75,0,0,0,192.94,229.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.3,226.36a4.41,4.41,0,0,1,.17-1,5.1,5.1,0,0,1,.35-.9,3.79,3.79,0,0,1,.52-.78,3,3,0,0,1,.68-.56,1.69,1.69,0,0,1,.72-.24.79.79,0,0,1,.54.19,1.35,1.35,0,0,1,.35.6,3.5,3.5,0,0,1,.12,1V225a.49.49,0,0,1-.06.23.45.45,0,0,1-.14.16L198,226.85v.05c0,.45.11.74.31.87a.68.68,0,0,0,.74-.06,2.2,2.2,0,0,0,.62-.51,5.63,5.63,0,0,0,.33-.54,1.09,1.09,0,0,1,.1-.17l.14-.11.22-.13a.16.16,0,0,1,.15,0,.15.15,0,0,1,.06.16,2.26,2.26,0,0,1-.13.47,2.53,2.53,0,0,1-.31.58,3.64,3.64,0,0,1-.49.59,3.71,3.71,0,0,1-.69.53,1.43,1.43,0,0,1-.67.21.81.81,0,0,1-.53-.18,1.32,1.32,0,0,1-.35-.51,2.7,2.7,0,0,1-.17-.81A7.06,7.06,0,0,1,197.3,226.36ZM198,226l2.1-1.22v0a1,1,0,0,0-.28-.81.72.72,0,0,0-.77.08,2.12,2.12,0,0,0-.41.33,3.17,3.17,0,0,0-.33.46,2.51,2.51,0,0,0-.22.56,2.89,2.89,0,0,0-.09.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.34,221.94a3.23,3.23,0,0,1,.15-.34,2.39,2.39,0,0,1,.21-.34A3.74,3.74,0,0,1,203,221a2.07,2.07,0,0,1,.37-.27,1.13,1.13,0,0,1,.76-.21.66.66,0,0,1,.47.37c.06-.16.13-.31.2-.46A3.78,3.78,0,0,1,205,220a2.91,2.91,0,0,1,.33-.37,2.07,2.07,0,0,1,.43-.31c.5-.3.87-.31,1.1,0a2.32,2.32,0,0,1,.34,1.46v2.76a.49.49,0,0,1-.06.23.32.32,0,0,1-.14.16l-.27.16a.14.14,0,0,1-.15,0,.18.18,0,0,1-.06-.15v-2.67a1.52,1.52,0,0,0-.22-1c-.15-.16-.37-.15-.66,0a1.67,1.67,0,0,0-.64.72,2.79,2.79,0,0,0-.25,1.22v2.74a.37.37,0,0,1-.06.22.28.28,0,0,1-.14.16l-.27.16a.12.12,0,0,1-.15,0,.2.2,0,0,1-.06-.16V222.6a1.56,1.56,0,0,0-.22-1c-.15-.16-.37-.15-.66,0a1.57,1.57,0,0,0-.64.72,2.73,2.73,0,0,0-.24,1.22v2.73a.41.41,0,0,1-.07.23.32.32,0,0,1-.14.16l-.27.16a.14.14,0,0,1-.15,0,.21.21,0,0,1-.06-.15V222a.6.6,0,0,1,.06-.22.34.34,0,0,1,.15-.16l.27-.16c.06,0,.11,0,.14,0a.17.17,0,0,1,.07.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,222a2.48,2.48,0,0,1,.12-.77,3,3,0,0,1,.33-.7,4.17,4.17,0,0,1,.49-.62,6.2,6.2,0,0,1,.6-.55l1-.84v-.13c0-.33-.08-.54-.25-.61a.67.67,0,0,0-.62.1,1.47,1.47,0,0,0-.5.45,3.19,3.19,0,0,0-.29.55.49.49,0,0,1-.1.16.4.4,0,0,1-.14.11l-.22.13c-.06,0-.11,0-.15,0a.18.18,0,0,1-.06-.16,2,2,0,0,1,.14-.52,2.57,2.57,0,0,1,.31-.59,3.51,3.51,0,0,1,.46-.56,2.53,2.53,0,0,1,.55-.44,1.76,1.76,0,0,1,.62-.23.74.74,0,0,1,.5.1.82.82,0,0,1,.32.43,2.13,2.13,0,0,1,.12.78v3a.46.46,0,0,1-.06.22.34.34,0,0,1-.15.16l-.27.16a.12.12,0,0,1-.15,0,.2.2,0,0,1-.06-.16v-.41a1.84,1.84,0,0,1-.2.46,4.46,4.46,0,0,1-.33.43,3.3,3.3,0,0,1-.38.37,2.31,2.31,0,0,1-.37.26,1.39,1.39,0,0,1-.54.2.76.76,0,0,1-.41-.05.6.6,0,0,1-.26-.3A1.06,1.06,0,0,1,208,222Zm1.38-.25a2.05,2.05,0,0,0,.5-.39,2.85,2.85,0,0,0,.38-.53,2.52,2.52,0,0,0,.25-.61,2.36,2.36,0,0,0,.08-.65v-.25l-.88.7a4.42,4.42,0,0,0-.75.75,1.32,1.32,0,0,0-.28.74.58.58,0,0,0,0,.19.33.33,0,0,0,.12.14.31.31,0,0,0,.22,0A.85.85,0,0,0,209.42,221.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.17,214.05a.46.46,0,0,1-.06.22.34.34,0,0,1-.15.16l-.42.25a.14.14,0,0,1-.15,0,.21.21,0,0,1,0-.15V214a.68.68,0,0,1,0-.23.47.47,0,0,1,.15-.16l.42-.24a.12.12,0,0,1,.15,0,.18.18,0,0,1,.06.16Zm-.08,6a.49.49,0,0,1-.06.23.45.45,0,0,1-.14.16l-.28.16a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-4.66a.46.46,0,0,1,.06-.22.38.38,0,0,1,.14-.16l.28-.16a.11.11,0,0,1,.14,0,.2.2,0,0,1,.06.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.9,219a.46.46,0,0,1-.06.22.36.36,0,0,1-.15.17l-.27.16a.14.14,0,0,1-.15,0,.18.18,0,0,1-.06-.16v-6.55a.46.46,0,0,1,.06-.22.34.34,0,0,1,.15-.16l.27-.16c.06,0,.11,0,.15,0a.2.2,0,0,1,.06.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.63,217.09a.14.14,0,0,1,.15,0,.18.18,0,0,1,.06.15v.67a.53.53,0,0,1-.06.23.39.39,0,0,1-.15.16l-.5.29a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.16v-.67a.49.49,0,0,1,.06-.22.38.38,0,0,1,.14-.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.31,215.08a1.79,1.79,0,0,0,.13.61.73.73,0,0,0,.25.31.54.54,0,0,0,.33.08,1,1,0,0,0,.36-.13,2.11,2.11,0,0,0,.62-.53,2.37,2.37,0,0,0,.39-.83,1.15,1.15,0,0,1,.11-.28.43.43,0,0,1,.14-.13l.22-.13a.12.12,0,0,1,.15,0,.18.18,0,0,1,.06.16,2.68,2.68,0,0,1-.12.59,3.71,3.71,0,0,1-.32.72,4.76,4.76,0,0,1-.52.71,2.78,2.78,0,0,1-.73.59,1.49,1.49,0,0,1-.73.24.79.79,0,0,1-.54-.18,1.16,1.16,0,0,1-.34-.53,2.74,2.74,0,0,1-.14-.82c0-.1,0-.23,0-.38a2.8,2.8,0,0,1,0-.42,5,5,0,0,1,.49-1.91,3.94,3.94,0,0,1,.54-.79,2.78,2.78,0,0,1,.72-.6,1.67,1.67,0,0,1,.73-.25,1,1,0,0,1,.52.11.78.78,0,0,1,.32.35,1.21,1.21,0,0,1,.12.45.46.46,0,0,1-.06.22.36.36,0,0,1-.15.17l-.22.13a.15.15,0,0,1-.14,0s-.07-.06-.11-.15-.22-.35-.39-.37a1,1,0,0,0-.62.18,1.63,1.63,0,0,0-.37.3,2,2,0,0,0-.33.45,3.26,3.26,0,0,0-.24.6,3.45,3.45,0,0,0-.13.75C218.3,214.64,218.3,214.87,218.31,215.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.56,209a1.88,1.88,0,0,1,.72-.25.82.82,0,0,1,.54.15,1,1,0,0,1,.36.5,2.9,2.9,0,0,1,.16.81v.94a5.5,5.5,0,0,1-.17,1,3.91,3.91,0,0,1-.35.9,3.8,3.8,0,0,1-.54.77,3.11,3.11,0,0,1-.72.58,1.72,1.72,0,0,1-.72.25.82.82,0,0,1-.54-.15A1,1,0,0,1,222,214a2.58,2.58,0,0,1-.16-.81c0-.06,0-.12,0-.2v-.52c0-.09,0-.16,0-.22a4.85,4.85,0,0,1,.16-1,3.82,3.82,0,0,1,.35-.91,4.1,4.1,0,0,1,.54-.77A3.11,3.11,0,0,1,223.56,209Zm1.09,2.49c0-.12,0-.26,0-.42s0-.31,0-.42a1.79,1.79,0,0,0-.09-.5.67.67,0,0,0-.21-.33.47.47,0,0,0-.33-.11,1,1,0,0,0-.46.15,2.12,2.12,0,0,0-.46.38,2.34,2.34,0,0,0-.33.49,2.75,2.75,0,0,0-.2.57,3.11,3.11,0,0,0-.1.61c0,.13,0,.27,0,.44s0,.29,0,.4a1.77,1.77,0,0,0,.1.5.66.66,0,0,0,.2.33.47.47,0,0,0,.33.11,1,1,0,0,0,.46-.15,1.7,1.7,0,0,0,.46-.38,2.27,2.27,0,0,0,.33-.48,2.66,2.66,0,0,0,.21-.58A3.1,3.1,0,0,0,224.65,211.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,207.72a3.4,3.4,0,0,1,.16-.34,3.79,3.79,0,0,1,.2-.34,2,2,0,0,1,.28-.31,1.69,1.69,0,0,1,.36-.27,1.14,1.14,0,0,1,.76-.21.62.62,0,0,1,.47.37c.07-.16.13-.31.21-.46a2.67,2.67,0,0,1,.25-.43,2.91,2.91,0,0,1,.33-.37,2.4,2.4,0,0,1,.43-.32c.51-.29.87-.3,1.1,0a2.31,2.31,0,0,1,.35,1.46v2.76a.53.53,0,0,1-.06.23.39.39,0,0,1-.15.16l-.27.16c-.06,0-.11,0-.14,0s-.06-.08-.06-.15V207a1.51,1.51,0,0,0-.23-1c-.15-.16-.37-.16-.66,0a1.68,1.68,0,0,0-.64.72,2.76,2.76,0,0,0-.24,1.22v2.74a.46.46,0,0,1-.06.22.38.38,0,0,1-.14.16l-.28.16a.12.12,0,0,1-.14,0,.16.16,0,0,1-.06-.15v-2.67a1.53,1.53,0,0,0-.23-1c-.15-.16-.37-.15-.66,0a1.62,1.62,0,0,0-.64.72,2.72,2.72,0,0,0-.24,1.21v2.74a.46.46,0,0,1-.06.22.49.49,0,0,1-.14.17l-.28.16a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.16V207.8a.46.46,0,0,1,.06-.22.49.49,0,0,1,.14-.17l.28-.16a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.55,220.05a.41.41,0,0,1-.21-.76L260.3,157a.4.4,0,0,1,.55.15.41.41,0,0,1-.15.55L152.75,220A.41.41,0,0,1,152.55,220.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,330.55a.39.39,0,0,1-.35-.2.4.4,0,0,1,.14-.55l47.31-27.31a.4.4,0,0,1,.55.14.4.4,0,0,1-.15.55l-47.3,27.31A.41.41,0,0,1,213.2,330.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.55,365.56a.4.4,0,0,1-.2-.75l47.3-27.31a.4.4,0,0,1,.4.7l-47.3,27.31A.39.39,0,0,1,152.55,365.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22,334.47a5.41,5.41,0,0,1,.14-1,5,5,0,0,1,.37-1,4.38,4.38,0,0,1,.62-.88,3.57,3.57,0,0,1,.87-.7,2.13,2.13,0,0,1,.87-.31.89.89,0,0,1,.61.18,1.15,1.15,0,0,1,.37.56,2.83,2.83,0,0,1,.15.88c0,.11,0,.24,0,.37s0,.28,0,.43,0,.3,0,.44,0,.27,0,.39a5.41,5.41,0,0,1-.14,1,4.69,4.69,0,0,1-.37,1,4.12,4.12,0,0,1-.62.88,3.72,3.72,0,0,1-.87.7,2.24,2.24,0,0,1-.87.31.91.91,0,0,1-.62-.17,1.26,1.26,0,0,1-.37-.57,3.17,3.17,0,0,1-.14-.87c0-.11,0-.24,0-.38v-.86C203.21,334.72,203.21,334.59,203.22,334.47Zm3.08-1.74a1,1,0,0,0-.31-.83.72.72,0,0,0-.77.09,2,2,0,0,0-.77.8,2.6,2.6,0,0,0-.31,1.2c0,.23,0,.49,0,.77s0,.54,0,.76a1,1,0,0,0,.31.83.75.75,0,0,0,.77-.09,2,2,0,0,0,.77-.8,2.65,2.65,0,0,0,.31-1.19c0-.23,0-.49,0-.78S206.31,333,206.3,332.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,331.07a1.5,1.5,0,0,0-.59.58,1.93,1.93,0,0,0-.18.89v2.37a.41.41,0,0,1-.06.2.31.31,0,0,1-.12.15l-.52.3a.1.1,0,0,1-.13,0,.16.16,0,0,1-.06-.14v-4.24a.41.41,0,0,1,.06-.2.32.32,0,0,1,.13-.15l.52-.3s.09,0,.12,0a.16.16,0,0,1,.06.14v.21a3,3,0,0,1,.38-.55,2,2,0,0,1,.53-.43l.3-.18a.15.15,0,0,1,.13,0,.17.17,0,0,1,.06.14v.61a.41.41,0,0,1-.06.2.32.32,0,0,1-.13.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.49,260a2.31,2.31,0,0,1-1.18-.31,3.69,3.69,0,0,1-1.5-3.36V245.89c0-2.85,1.68-6,3.84-7.29l95.21-55a2.8,2.8,0,0,1,2.88-.19,3.69,3.69,0,0,1,1.5,3.35v10.49c0,2.84-1.69,6.05-3.84,7.29h0l-95.21,55A3.48,3.48,0,0,1,157.49,260Zm98-75.84a2.29,2.29,0,0,0-1.14.36l-95.21,55c-1.83,1.05-3.31,3.9-3.31,6.36v10.48a2.69,2.69,0,0,0,1,2.43,1.83,1.83,0,0,0,1.8-.19l95.21-55c1.82-1,3.3-3.91,3.3-6.36V186.79a2.7,2.7,0,0,0-1-2.42A1.3,1.3,0,0,0,255.54,184.2Zm-1.41,19.91h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.15,266.42a2.57,2.57,0,0,1,.69-.28.93.93,0,0,1,.58.06.87.87,0,0,1,.39.43,2.06,2.06,0,0,1,.14.86,3.49,3.49,0,0,1-.14,1,4.08,4.08,0,0,1-.39.9,3.52,3.52,0,0,1-.58.73,3.43,3.43,0,0,1-.69.53l-1.38.8v2.44a.49.49,0,0,1-.06.23.38.38,0,0,1-.14.16l-.31.18a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-6.46a.49.49,0,0,1,.06-.22.38.38,0,0,1,.14-.16Zm-1.38,4.17,1.34-.78A2.29,2.29,0,0,0,159,269a2.06,2.06,0,0,0,.29-1.12c0-.42-.09-.67-.29-.75a1,1,0,0,0-.84.19l-1.34.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.42,270.79a2.48,2.48,0,0,1,.12-.77,3.19,3.19,0,0,1,.33-.7,3.61,3.61,0,0,1,.49-.62,7.39,7.39,0,0,1,.59-.54l1.06-.84v-.13c0-.34-.08-.55-.25-.62a.7.7,0,0,0-.63.11,1.41,1.41,0,0,0-.49.44,2.62,2.62,0,0,0-.29.55.49.49,0,0,1-.1.16.58.58,0,0,1-.14.12l-.23.13a.12.12,0,0,1-.14,0c-.05,0-.06-.08-.06-.16a2.07,2.07,0,0,1,.13-.52,3.09,3.09,0,0,1,.32-.59,3.94,3.94,0,0,1,.45-.56,2.66,2.66,0,0,1,.55-.43,1.92,1.92,0,0,1,.63-.24.72.72,0,0,1,.49.1.87.87,0,0,1,.33.43,2.39,2.39,0,0,1,.11.78v3.05a.46.46,0,0,1-.06.22.49.49,0,0,1-.14.17l-.28.16a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.16v-.41a1.46,1.46,0,0,1-.21.46,2.24,2.24,0,0,1-.33.43,3.49,3.49,0,0,1-.75.64,1.46,1.46,0,0,1-.53.2.71.71,0,0,1-.42-.06.67.67,0,0,1-.26-.29A1.29,1.29,0,0,1,160.42,270.79Zm1.38-.25a2,2,0,0,0,.49-.39,2.9,2.9,0,0,0,.39-.53,3,3,0,0,0,.25-.61,2.8,2.8,0,0,0,.08-.64v-.25l-.88.7a3.32,3.32,0,0,0-.75.75,1.2,1.2,0,0,0-.28.73.38.38,0,0,0,0,.19.29.29,0,0,0,.12.15.34.34,0,0,0,.21,0A.83.83,0,0,0,161.8,270.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,266.86a.34.34,0,0,0-.08-.27.32.32,0,0,0-.23-.08,1.68,1.68,0,0,0-.4.06l-.57.16c-.4.12-.69.1-.85-.07a1.11,1.11,0,0,1-.24-.79,2.32,2.32,0,0,1,.09-.62,2.85,2.85,0,0,1,.27-.63,2.8,2.8,0,0,1,.45-.59,2.86,2.86,0,0,1,.64-.49,2.09,2.09,0,0,1,.64-.26,1,1,0,0,1,.46,0,.56.56,0,0,1,.29.2.57.57,0,0,1,.1.31.39.39,0,0,1,0,.23.47.47,0,0,1-.15.16l-.25.14-.11,0a.11.11,0,0,1-.11-.05.38.38,0,0,0-.29-.11,1.06,1.06,0,0,0-.53.19,1.77,1.77,0,0,0-.56.49,1,1,0,0,0-.21.59.45.45,0,0,0,.06.27.26.26,0,0,0,.19.09,1.38,1.38,0,0,0,.36,0l.55-.15a1.64,1.64,0,0,1,.58-.08.77.77,0,0,1,.37.13.59.59,0,0,1,.2.32,1.56,1.56,0,0,1,.06.46,2.17,2.17,0,0,1-.1.64,3.67,3.67,0,0,1-.31.67,4,4,0,0,1-.5.62,2.93,2.93,0,0,1-.65.51,1.78,1.78,0,0,1-.65.25,1.13,1.13,0,0,1-.49,0,.56.56,0,0,1-.31-.2.6.6,0,0,1-.12-.32.49.49,0,0,1,.06-.22.33.33,0,0,1,.15-.16l.26-.16.11,0s.08,0,.11.05a.37.37,0,0,0,.33.14,1.19,1.19,0,0,0,.55-.19,1.41,1.41,0,0,0,.32-.24,2,2,0,0,0,.29-.3,1.94,1.94,0,0,0,.2-.33A.77.77,0,0,0,167,266.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.79,264.67a.36.36,0,0,0-.08-.27.32.32,0,0,0-.23-.08,1.77,1.77,0,0,0-.4.07l-.57.15c-.4.12-.69.1-.85-.07a1.1,1.1,0,0,1-.24-.78,2.39,2.39,0,0,1,.09-.63,2.85,2.85,0,0,1,.27-.63,2.8,2.8,0,0,1,.45-.59,2.86,2.86,0,0,1,.64-.49,2,2,0,0,1,.64-.26,1,1,0,0,1,.46,0,.56.56,0,0,1,.29.2.58.58,0,0,1,.1.32.32.32,0,0,1-.06.22.38.38,0,0,1-.14.16l-.25.15a.29.29,0,0,1-.11,0,.1.1,0,0,1-.11,0,.36.36,0,0,0-.29-.12,1.06,1.06,0,0,0-.53.19,1.67,1.67,0,0,0-.56.49,1,1,0,0,0-.21.59.45.45,0,0,0,.06.27.25.25,0,0,0,.19.09,1.38,1.38,0,0,0,.36,0l.55-.15a1.9,1.9,0,0,1,.58-.08.69.69,0,0,1,.37.14.56.56,0,0,1,.2.31,1.6,1.6,0,0,1,.06.46,1.91,1.91,0,0,1-.11.64,2.69,2.69,0,0,1-.31.67,3.1,3.1,0,0,1-.49.62,2.93,2.93,0,0,1-.65.51,2,2,0,0,1-.65.26,1.12,1.12,0,0,1-.49,0,.53.53,0,0,1-.31-.2.59.59,0,0,1-.12-.31.53.53,0,0,1,.06-.23.39.39,0,0,1,.15-.16l.27-.16.1,0s.08,0,.11.05a.4.4,0,0,0,.33.15,1.23,1.23,0,0,0,.55-.2,1.41,1.41,0,0,0,.32-.24,1.64,1.64,0,0,0,.29-.3,1.94,1.94,0,0,0,.2-.33A.77.77,0,0,0,170.79,264.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.92,261.53l.84-3.82a1.45,1.45,0,0,1,.08-.21.52.52,0,0,1,.18-.18l.24-.14a.1.1,0,0,1,.13,0s.05.07.05.14v.08l-1.15,5.26a1.35,1.35,0,0,1-.08.24.35.35,0,0,1-.15.17l-.23.13c-.06,0-.11,0-.14,0a.38.38,0,0,1-.09-.15l-.89-2.8-.89,3.83a1.84,1.84,0,0,1-.09.25.39.39,0,0,1-.14.17l-.24.13c-.06,0-.11,0-.14,0a.48.48,0,0,1-.08-.16L172,260.55v-.08a.39.39,0,0,1,.05-.2.35.35,0,0,1,.13-.14l.24-.14c.08-.05.13-.05.17,0a.31.31,0,0,1,.09.11l.84,2.85.89-3.85a1,1,0,0,1,.08-.2.35.35,0,0,1,.16-.18l.16-.09c.08-.05.13-.05.16,0a.19.19,0,0,1,.07.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.76,255.64a1.59,1.59,0,0,1,.72-.25.81.81,0,0,1,.54.14,1.08,1.08,0,0,1,.36.5,2.58,2.58,0,0,1,.16.81c0,.06,0,.13,0,.21v.52c0,.08,0,.15,0,.21a4.65,4.65,0,0,1-.17,1,3.91,3.91,0,0,1-.35.9,3.8,3.8,0,0,1-.54.77,3.11,3.11,0,0,1-.72.58,1.64,1.64,0,0,1-.72.25.86.86,0,0,1-.53-.14,1.08,1.08,0,0,1-.36-.5,2.58,2.58,0,0,1-.16-.81,1.15,1.15,0,0,1,0-.2c0-.08,0-.17,0-.26s0-.17,0-.26a1.48,1.48,0,0,1,0-.22,4.85,4.85,0,0,1,.16-1,4.54,4.54,0,0,1,.36-.91,4.12,4.12,0,0,1,.53-.76A3.28,3.28,0,0,1,179.76,255.64Zm1.1,2.48c0-.12,0-.26,0-.42s0-.3,0-.42a2.21,2.21,0,0,0-.1-.5.78.78,0,0,0-.21-.33.52.52,0,0,0-.33-.11.91.91,0,0,0-.46.16,1.78,1.78,0,0,0-.45.37,2.34,2.34,0,0,0-.33.49,2.78,2.78,0,0,0-.21.57,4.22,4.22,0,0,0-.1.62c0,.12,0,.27,0,.43s0,.3,0,.41a2.46,2.46,0,0,0,.1.5.78.78,0,0,0,.21.33.47.47,0,0,0,.33.1.92.92,0,0,0,.45-.15,1.67,1.67,0,0,0,.46-.37,2.34,2.34,0,0,0,.33-.49,2.78,2.78,0,0,0,.21-.57A4.22,4.22,0,0,0,180.86,258.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.47,253a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v.32a.49.49,0,0,1-.06.23.38.38,0,0,1-.14.16l-.44.25a1.76,1.76,0,0,0-.86,1.65v2.91a.49.49,0,0,1-.06.23.45.45,0,0,1-.14.16l-.28.16a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-4.66a.46.46,0,0,1,.06-.22.38.38,0,0,1,.14-.16l.28-.16a.1.1,0,0,1,.14,0,.16.16,0,0,1,.06.15v.31a2.5,2.5,0,0,1,.36-.65,2.07,2.07,0,0,1,.55-.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.75,251.61a1.17,1.17,0,0,1,.74-.22.78.78,0,0,1,.42.23v-2.21a.59.59,0,0,1,.05-.22.43.43,0,0,1,.15-.17l.27-.16a.14.14,0,0,1,.15,0,.18.18,0,0,1,.06.16v6.55a.46.46,0,0,1-.06.22.34.34,0,0,1-.15.16l-.27.16a.16.16,0,0,1-.15,0,.23.23,0,0,1-.05-.16v-.31a3.42,3.42,0,0,1-.43.72,2.66,2.66,0,0,1-.73.63,1.33,1.33,0,0,1-.66.21.77.77,0,0,1-.53-.17,1.22,1.22,0,0,1-.36-.54,3.09,3.09,0,0,1-.16-.9V255a5.3,5.3,0,0,1,.16-1.08,4.55,4.55,0,0,1,.36-1,4.2,4.2,0,0,1,.53-.77A2.38,2.38,0,0,1,186.75,251.61Zm1.16,2.45v-.79a1.19,1.19,0,0,0-.32-.91.69.69,0,0,0-.77.06,2,2,0,0,0-.78.87,3.29,3.29,0,0,0-.31,1.32,5.23,5.23,0,0,0,0,.56,1.35,1.35,0,0,0,.31,1q.28.25.78,0a2.09,2.09,0,0,0,.76-.82A2.81,2.81,0,0,0,187.91,254.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.22,289.38a3.74,3.74,0,0,1,.14-1,4.25,4.25,0,0,1,.37-.95,3.85,3.85,0,0,1,.55-.81,2.66,2.66,0,0,1,.67-.56,1.5,1.5,0,0,1,.68-.22.89.89,0,0,1,.55.18,1.14,1.14,0,0,1,.37.52,2.24,2.24,0,0,1,.13.82,3.72,3.72,0,0,1-.13,1,4.57,4.57,0,0,1-.37.95,4.27,4.27,0,0,1-.55.81,2.75,2.75,0,0,1-.68.57,1.33,1.33,0,0,1-.67.21.92.92,0,0,1-.55-.17,1.12,1.12,0,0,1-.37-.52A2.29,2.29,0,0,1,161.22,289.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,286.16a3.72,3.72,0,0,1,.13-1,4.57,4.57,0,0,1,.37-.95,4.27,4.27,0,0,1,.55-.81,2.58,2.58,0,0,1,.68-.57,1.33,1.33,0,0,1,.67-.21.92.92,0,0,1,.55.17,1.18,1.18,0,0,1,.37.53,2.19,2.19,0,0,1,.14.82,3.74,3.74,0,0,1-.14,1,4.57,4.57,0,0,1-.37.95,3.85,3.85,0,0,1-.55.81,2.71,2.71,0,0,1-.67.57,1.65,1.65,0,0,1-.68.21.89.89,0,0,1-.55-.18,1.14,1.14,0,0,1-.37-.52A2.24,2.24,0,0,1,166.81,286.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.39,282.93a3.65,3.65,0,0,1,.13-1,4.93,4.93,0,0,1,.37-.95,4.27,4.27,0,0,1,.55-.81,2.75,2.75,0,0,1,.68-.57,1.37,1.37,0,0,1,.68-.21.82.82,0,0,1,.55.17,1.22,1.22,0,0,1,.37.52,2.54,2.54,0,0,1,.13.83,4.11,4.11,0,0,1-.13,1,4.93,4.93,0,0,1-.37.95,4.27,4.27,0,0,1-.55.81,2.75,2.75,0,0,1-.68.57,1.37,1.37,0,0,1-.68.21.82.82,0,0,1-.55-.17,1.22,1.22,0,0,1-.37-.52A2.26,2.26,0,0,1,172.39,282.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,279.71a3.74,3.74,0,0,1,.14-1,4.07,4.07,0,0,1,.37-1A3.85,3.85,0,0,1,179,277a2.71,2.71,0,0,1,.67-.57,1.61,1.61,0,0,1,.68-.21.89.89,0,0,1,.55.18,1.14,1.14,0,0,1,.37.52,2.24,2.24,0,0,1,.13.82,3.72,3.72,0,0,1-.13,1,4.57,4.57,0,0,1-.37.95,4.27,4.27,0,0,1-.55.81,2.75,2.75,0,0,1-.68.57,1.33,1.33,0,0,1-.67.21.87.87,0,0,1-.55-.18,1,1,0,0,1-.37-.52A2.19,2.19,0,0,1,178,279.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.56,276.49a3.72,3.72,0,0,1,.13-1,4.57,4.57,0,0,1,.37-.95,4.27,4.27,0,0,1,.55-.81,2.71,2.71,0,0,1,.67-.57A1.4,1.4,0,0,1,186,273a.92.92,0,0,1,.55.17,1.18,1.18,0,0,1,.37.53,2.19,2.19,0,0,1,.14.82,3.74,3.74,0,0,1-.14,1,4.57,4.57,0,0,1-.37.95,3.85,3.85,0,0,1-.55.81,2.58,2.58,0,0,1-.68.57,1.57,1.57,0,0,1-.67.21.89.89,0,0,1-.55-.18,1.14,1.14,0,0,1-.37-.52A2.24,2.24,0,0,1,183.56,276.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.14,273.26a3.65,3.65,0,0,1,.13-1,4.93,4.93,0,0,1,.37-1,4.27,4.27,0,0,1,.55-.81,2.75,2.75,0,0,1,.68-.57,1.36,1.36,0,0,1,.67-.21.83.83,0,0,1,.56.17,1.13,1.13,0,0,1,.36.52,2.25,2.25,0,0,1,.14.83,3.67,3.67,0,0,1-.14,1,4.33,4.33,0,0,1-.36.95,3.89,3.89,0,0,1-.56.81,2.54,2.54,0,0,1-.67.57,1.37,1.37,0,0,1-.68.21.82.82,0,0,1-.55-.17,1.22,1.22,0,0,1-.37-.52A2.3,2.3,0,0,1,189.14,273.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,270a3.74,3.74,0,0,1,.14-1,4.07,4.07,0,0,1,.37-.95,3.85,3.85,0,0,1,.55-.81,2.71,2.71,0,0,1,.67-.57,1.37,1.37,0,0,1,.68-.21.89.89,0,0,1,.55.18,1.14,1.14,0,0,1,.37.52,2.24,2.24,0,0,1,.13.82,3.72,3.72,0,0,1-.13,1,4.57,4.57,0,0,1-.37,1,4.27,4.27,0,0,1-.55.81,2.75,2.75,0,0,1-.68.57,1.33,1.33,0,0,1-.67.21.92.92,0,0,1-.55-.17,1.1,1.1,0,0,1-.37-.53A2.19,2.19,0,0,1,194.72,270Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.31,266.82a3.72,3.72,0,0,1,.13-1,4.57,4.57,0,0,1,.37-.95,4.27,4.27,0,0,1,.55-.81,2.71,2.71,0,0,1,.67-.57,1.4,1.4,0,0,1,.68-.21.86.86,0,0,1,.55.17,1.2,1.2,0,0,1,.37.52,2.29,2.29,0,0,1,.14.83,3.74,3.74,0,0,1-.14,1,4.79,4.79,0,0,1-.37.95,3.54,3.54,0,0,1-.55.8,2.63,2.63,0,0,1-.68.58,1.57,1.57,0,0,1-.67.21.89.89,0,0,1-.55-.18,1.14,1.14,0,0,1-.37-.52A2.24,2.24,0,0,1,200.31,266.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5,301.18a2.32,2.32,0,0,1-1.19-.31,3.69,3.69,0,0,1-1.5-3.36V287c0-2.85,1.68-6,3.84-7.29l95.21-55a2.8,2.8,0,0,1,2.88-.19,3.69,3.69,0,0,1,1.5,3.35v10.49c0,2.84-1.69,6.05-3.84,7.29h0l-95.21,55A3.47,3.47,0,0,1,157.5,301.18Zm98-75.84a2.29,2.29,0,0,0-1.14.36l-95.21,55c-1.83,1.05-3.31,3.9-3.31,6.36v10.48a2.69,2.69,0,0,0,1,2.43,1.83,1.83,0,0,0,1.8-.19l95.21-55c1.82-1.05,3.3-3.91,3.3-6.36V227.93a2.7,2.7,0,0,0-1-2.42A1.3,1.3,0,0,0,255.54,225.34Zm-1.41,19.91h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,294.55l-95.21,55c-2,1.14-3.58-.07-3.58-2.7V330.6c0-2.63,1.6-5.69,3.58-6.83l95.21-55c2-1.14,3.57.07,3.57,2.7v16.22C257.7,290.35,256.1,293.41,254.13,294.55Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,312.34a3,3,0,0,1,1.19-.44,1.46,1.46,0,0,1,.86.11,1.1,1.1,0,0,1,.52.5,1.6,1.6,0,0,1,.19.71.48.48,0,0,1-.07.3.54.54,0,0,1-.2.22l-.7.41a.36.36,0,0,1-.26.06.45.45,0,0,1-.16-.15.71.71,0,0,0-.46-.32,1.44,1.44,0,0,0-.91.28,3.31,3.31,0,0,0-.5.36,3,3,0,0,0-.41.46,2.06,2.06,0,0,0-.28.5,1.54,1.54,0,0,0-.1.51.75.75,0,0,0,.1.45.37.37,0,0,0,.32.15,2.15,2.15,0,0,0,.6-.08l.93-.26a4.72,4.72,0,0,1,1-.19,1.33,1.33,0,0,1,.72.15,1.08,1.08,0,0,1,.41.52,2.6,2.6,0,0,1,.14.91,3.88,3.88,0,0,1-.21,1.23,4.83,4.83,0,0,1-.57,1.22,6,6,0,0,1-.92,1.12,6.2,6.2,0,0,1-1.22.92,3.73,3.73,0,0,1-1.08.44,1.75,1.75,0,0,1-.91,0,1.13,1.13,0,0,1-.64-.46,1.72,1.72,0,0,1-.27-.91.5.5,0,0,1,.08-.31.49.49,0,0,1,.19-.21l.71-.41a.33.33,0,0,1,.26-.07.27.27,0,0,1,.15.15,1.1,1.1,0,0,0,.17.25.53.53,0,0,0,.27.16,1.1,1.1,0,0,0,.43,0,2.7,2.7,0,0,0,.64-.28,5.57,5.57,0,0,0,.59-.4,2.84,2.84,0,0,0,.49-.49,2.43,2.43,0,0,0,.34-.54,1.39,1.39,0,0,0,.14-.6.47.47,0,0,0-.15-.4.58.58,0,0,0-.42-.08,6.14,6.14,0,0,0-.72.16l-1,.26a3.9,3.9,0,0,1-.88.12,1,1,0,0,1-.63-.18,1.08,1.08,0,0,1-.37-.55,3.19,3.19,0,0,1-.12-1,4.11,4.11,0,0,1,.2-1.23,5.46,5.46,0,0,1,.56-1.2,5.53,5.53,0,0,1,.84-1A5.33,5.33,0,0,1,193.3,312.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.41,309.39a.18.18,0,0,1,.2,0,.26.26,0,0,1,.08.21v1a.75.75,0,0,1-.08.31.51.51,0,0,1-.2.21l-.86.5c-.08,0-.14,0-.19,0a.23.23,0,0,1-.09-.21v-1a.58.58,0,0,1,.09-.3.46.46,0,0,1,.19-.22Zm.22,9.05a.56.56,0,0,1-.08.3.46.46,0,0,1-.19.22l-.76.44c-.08.05-.14.05-.19,0a.23.23,0,0,1-.09-.21v-6.27a.61.61,0,0,1,.09-.3.52.52,0,0,1,.19-.22l.76-.44a.16.16,0,0,1,.19,0,.23.23,0,0,1,.08.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.31,318a2.4,2.4,0,0,0,.44-.33,3.47,3.47,0,0,0,.4-.51,3.23,3.23,0,0,0,.3-.65,2.67,2.67,0,0,0,.11-.75v-.49a3.05,3.05,0,0,1-.21.38,3.48,3.48,0,0,1-.32.45,3.57,3.57,0,0,1-.43.45,3,3,0,0,1-.56.4,1.65,1.65,0,0,1-.91.27,1.14,1.14,0,0,1-.7-.3,1.83,1.83,0,0,1-.45-.75,3.79,3.79,0,0,1-.19-1.08c0-.13,0-.28,0-.46s0-.34,0-.48a6.82,6.82,0,0,1,.64-2.57,5.88,5.88,0,0,1,.7-1.1,3.54,3.54,0,0,1,.91-.79,2.29,2.29,0,0,1,.56-.24,1.42,1.42,0,0,1,.43-.05.88.88,0,0,1,.32.08,1,1,0,0,1,.21.14v-.31a.67.67,0,0,1,.08-.3.62.62,0,0,1,.2-.22l.76-.44a.16.16,0,0,1,.19,0,.23.23,0,0,1,.08.21v6.3a5.66,5.66,0,0,1-.68,2.84,4.89,4.89,0,0,1-1.88,1.92,2.82,2.82,0,0,1-.95.36,1.47,1.47,0,0,1-.76,0,1,1,0,0,1-.51-.39,1.27,1.27,0,0,1-.22-.66.56.56,0,0,1,.08-.3.48.48,0,0,1,.2-.22l.68-.4c.1-.05.18-.06.24,0a1.41,1.41,0,0,1,.18.14.51.51,0,0,0,.35.17A1.47,1.47,0,0,0,202.31,318Zm-1.2-4.51a3.14,3.14,0,0,0,0,.75c0,.56.17.9.4,1a.83.83,0,0,0,.84-.1,2.4,2.4,0,0,0,.83-.87,3,3,0,0,0,.38-1.34,4,4,0,0,0,0-.52,3.63,3.63,0,0,0,0-.5,1.08,1.08,0,0,0-.38-.88.8.8,0,0,0-.83.08,2.35,2.35,0,0,0-.84.87A3.16,3.16,0,0,0,201.11,313.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.18,311.2a.61.61,0,0,1-.08.3.52.52,0,0,1-.19.22l-.76.44a.18.18,0,0,1-.2,0,.26.26,0,0,1-.08-.21v-3.41a1.73,1.73,0,0,0-.28-1.13c-.19-.21-.48-.21-.87,0a2.13,2.13,0,0,0-.84,1,3.51,3.51,0,0,0-.3,1.47v3.41a.58.58,0,0,1-.09.3.46.46,0,0,1-.19.22l-.76.44c-.08,0-.14.05-.19,0a.22.22,0,0,1-.08-.2v-6.27a.56.56,0,0,1,.08-.3.52.52,0,0,1,.19-.22l.76-.44a.16.16,0,0,1,.19,0,.23.23,0,0,1,.09.21v.31a4.89,4.89,0,0,1,.61-.94,3,3,0,0,1,.84-.71,2,2,0,0,1,1-.34.9.9,0,0,1,.67.3,1.7,1.7,0,0,1,.36.8,5.69,5.69,0,0,1,.1,1.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.91,299.29c.08-.05.14-.05.19,0a.24.24,0,0,1,.08.21v1.05a.56.56,0,0,1-.08.3.42.42,0,0,1-.19.22l-.87.5a.15.15,0,0,1-.19,0,.25.25,0,0,1-.08-.2v-1.05a.67.67,0,0,1,.08-.3.53.53,0,0,1,.19-.22Zm.22,9a.56.56,0,0,1-.08.3.46.46,0,0,1-.19.22l-.76.44a.18.18,0,0,1-.2,0,.26.26,0,0,1-.08-.21v-6.26a.67.67,0,0,1,.08-.3.54.54,0,0,1,.2-.22l.76-.44a.16.16,0,0,1,.19,0,.22.22,0,0,1,.08.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,304.7a.61.61,0,0,1-.08.3.6.6,0,0,1-.19.22l-.77.44a.17.17,0,0,1-.19,0,.26.26,0,0,1-.08-.21V302a1.73,1.73,0,0,0-.28-1.13c-.19-.21-.48-.21-.87,0a2.13,2.13,0,0,0-.84,1,3.52,3.52,0,0,0-.31,1.47v3.41a.56.56,0,0,1-.08.3.46.46,0,0,1-.19.22l-.76.44a.16.16,0,0,1-.19,0,.23.23,0,0,1-.09-.2v-6.27a.58.58,0,0,1,.09-.3.52.52,0,0,1,.19-.22l.76-.44a.16.16,0,0,1,.19,0,.23.23,0,0,1,.08.21v.3a5.79,5.79,0,0,1,.62-.93,3,3,0,0,1,.84-.71,2,2,0,0,1,1-.34.9.9,0,0,1,.67.3,1.7,1.7,0,0,1,.36.8,5.69,5.69,0,0,1,.1,1.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.66,303.76a1.8,1.8,0,0,1,.56-.22.71.71,0,0,1,.46,0,.63.63,0,0,1,.31.33,1.56,1.56,0,0,1,.12.68,2.79,2.79,0,0,1-.25,1.17,2.89,2.89,0,0,1-.62.9l.91,1.58a.24.24,0,0,1,0,.08.42.42,0,0,1,0,.15.24.24,0,0,1-.1.1l-.25.15c-.08.05-.14.05-.18,0a.22.22,0,0,1-.08-.09l-.87-1.53-1,.59v2a.41.41,0,0,1-.05.18.36.36,0,0,1-.11.13l-.25.14a.08.08,0,0,1-.11,0,.14.14,0,0,1,0-.12v-5.16a.41.41,0,0,1,0-.18.29.29,0,0,1,.11-.13Zm-1,3.22,1-.58a2,2,0,0,0,.67-.61,1.59,1.59,0,0,0,.24-.88c0-.34-.08-.54-.24-.59a.9.9,0,0,0-.67.18l-1,.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.7,305.7a3.36,3.36,0,0,1,.13-.76,3.85,3.85,0,0,1,.28-.72,3.07,3.07,0,0,1,.42-.62,2.31,2.31,0,0,1,.54-.45,1.27,1.27,0,0,1,.58-.19.56.56,0,0,1,.43.15,1.11,1.11,0,0,1,.28.48,2.88,2.88,0,0,1,.09.78v.22a.39.39,0,0,1,0,.18.3.3,0,0,1-.12.13l-2.06,1.19v.05a.82.82,0,0,0,.25.69.56.56,0,0,0,.59-.05,1.77,1.77,0,0,0,.5-.41,2.24,2.24,0,0,0,.26-.43.56.56,0,0,1,.09-.14.44.44,0,0,1,.1-.08l.18-.11a.13.13,0,0,1,.12,0s.05.06,0,.13a1.38,1.38,0,0,1-.1.37,1.85,1.85,0,0,1-.24.46,2.83,2.83,0,0,1-.4.48,3.06,3.06,0,0,1-.55.42,1.16,1.16,0,0,1-.54.17.59.59,0,0,1-.41-.15.92.92,0,0,1-.29-.41,2,2,0,0,1-.13-.64A4.57,4.57,0,0,1,167.7,305.7Zm.53-.28,1.69-1v0a.74.74,0,0,0-.23-.64c-.16-.11-.36-.09-.62.06a1.52,1.52,0,0,0-.32.26,2.07,2.07,0,0,0-.27.37,2.89,2.89,0,0,0-.18.44,2.65,2.65,0,0,0-.07.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.73,302.16a2.86,2.86,0,0,1,.12-.27,2,2,0,0,1,.17-.27,2.32,2.32,0,0,1,.21-.25,1.61,1.61,0,0,1,.3-.21.87.87,0,0,1,.6-.17.5.5,0,0,1,.38.29c.05-.12.11-.24.17-.36a1.45,1.45,0,0,1,.2-.34,1.92,1.92,0,0,1,.61-.56c.4-.23.7-.24.88,0a1.86,1.86,0,0,1,.27,1.16v2.22a.38.38,0,0,1,0,.17c0,.07-.07.11-.12.13l-.22.13a.08.08,0,0,1-.11,0s-.05-.06-.05-.12v-2.13a1.26,1.26,0,0,0-.18-.81c-.12-.12-.3-.12-.53,0a1.3,1.3,0,0,0-.51.57,2.2,2.2,0,0,0-.19,1v2.19a.45.45,0,0,1-.05.18.3.3,0,0,1-.12.13l-.22.12a.09.09,0,0,1-.11,0,.17.17,0,0,1-.05-.13v-2.13a1.21,1.21,0,0,0-.18-.8c-.12-.13-.3-.13-.53,0a1.3,1.3,0,0,0-.51.57,2.2,2.2,0,0,0-.19,1v2.19a.41.41,0,0,1,0,.18.3.3,0,0,1-.12.13l-.22.12a.09.09,0,0,1-.11,0,.17.17,0,0,1,0-.13v-3.72a.41.41,0,0,1,0-.18.36.36,0,0,1,.11-.13l.22-.13a.13.13,0,0,1,.12,0,.15.15,0,0,1,0,.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.37,300.7a4.13,4.13,0,0,1,.13-.77,4.48,4.48,0,0,1,.28-.72,3.38,3.38,0,0,1,.42-.62,2.31,2.31,0,0,1,.54-.45,1.4,1.4,0,0,1,.58-.19.64.64,0,0,1,.43.15,1,1,0,0,1,.28.48,3,3,0,0,1,.1.79v.21a.41.41,0,0,1,0,.18.26.26,0,0,1-.12.13l-2.06,1.19v.05c0,.36.09.59.25.69a.52.52,0,0,0,.59-.05,1.51,1.51,0,0,0,.5-.41,2,2,0,0,0,.26-.43.48.48,0,0,1,.09-.13.45.45,0,0,1,.1-.09l.18-.1a.11.11,0,0,1,.12,0s0,.07,0,.13a1.83,1.83,0,0,1-.11.37,1.85,1.85,0,0,1-.24.46,3.29,3.29,0,0,1-.39.48,2.65,2.65,0,0,1-.56.42,1.05,1.05,0,0,1-.54.17.64.64,0,0,1-.41-.14,1,1,0,0,1-.29-.41,2.34,2.34,0,0,1-.13-.65A4.45,4.45,0,0,1,176.37,300.7Zm.53-.29,1.69-1v0a.76.76,0,0,0-.23-.65c-.16-.11-.36-.08-.62.06a1.58,1.58,0,0,0-.32.27,2,2,0,0,0-.27.36,3,3,0,0,0-.18.45,2.53,2.53,0,0,0-.07.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4,297.16a1.59,1.59,0,0,1,.12-.27,1.24,1.24,0,0,1,.17-.27,1.27,1.27,0,0,1,.22-.25,1.3,1.3,0,0,1,.29-.22.92.92,0,0,1,.6-.17.54.54,0,0,1,.38.3c0-.13.11-.25.17-.37a1.68,1.68,0,0,1,.2-.34,2.55,2.55,0,0,1,.26-.3,1.83,1.83,0,0,1,.35-.25c.4-.23.7-.24.88,0a1.9,1.9,0,0,1,.27,1.17v2.21a.39.39,0,0,1,0,.18.38.38,0,0,1-.12.13l-.22.13a.11.11,0,0,1-.11,0,.14.14,0,0,1,0-.13v-2.13a1.21,1.21,0,0,0-.18-.8c-.12-.13-.3-.12-.53,0a1.28,1.28,0,0,0-.51.58,2.15,2.15,0,0,0-.19,1v2.19a.41.41,0,0,1-.05.18.38.38,0,0,1-.12.13l-.22.13a.11.11,0,0,1-.11,0,.16.16,0,0,1-.05-.13v-2.13a1.23,1.23,0,0,0-.18-.8c-.12-.13-.29-.12-.53,0a1.33,1.33,0,0,0-.51.58,2.15,2.15,0,0,0-.19,1v2.19a.41.41,0,0,1-.05.18.26.26,0,0,1-.12.13l-.22.13a.11.11,0,0,1-.11,0,.14.14,0,0,1-.05-.12v-3.73a.41.41,0,0,1,.05-.17.33.33,0,0,1,.11-.14l.22-.12q.08,0,.12,0a.14.14,0,0,1,.05.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66,293a1.06,1.06,0,0,1,.52-.17.62.62,0,0,1,.42.13.93.93,0,0,1,.29.43,2.32,2.32,0,0,1,.13.72v.52a4.06,4.06,0,0,1-.13.86,3.43,3.43,0,0,1-.29.76,2.88,2.88,0,0,1-.42.63,2.09,2.09,0,0,1-.52.43,1,1,0,0,1-.59.18.59.59,0,0,1-.34-.18v.24a.41.41,0,0,1,0,.18.29.29,0,0,1-.11.13l-.22.13s-.09,0-.12,0a.14.14,0,0,1,0-.12v-5.24a.41.41,0,0,1,0-.18.26.26,0,0,1,.12-.13l.22-.13a.08.08,0,0,1,.11,0,.14.14,0,0,1,0,.12v1.77a2.86,2.86,0,0,1,.33-.57A1.89,1.89,0,0,1,186.66,293Zm-.93,3a.89.89,0,0,0,.26.67.55.55,0,0,0,.61,0,1.55,1.55,0,0,0,.62-.69,2.75,2.75,0,0,0,.25-1.06,3.38,3.38,0,0,0,0-.45,1.1,1.1,0,0,0-.25-.76c-.15-.14-.36-.13-.62,0a1.57,1.57,0,0,0-.61.66,2.47,2.47,0,0,0-.26,1,3.22,3.22,0,0,0,0,.33A2.73,2.73,0,0,0,185.73,296Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.62,293.62a4,4,0,0,1,.13-.76,4.69,4.69,0,0,1,.28-.72,3.38,3.38,0,0,1,.42-.62,2.31,2.31,0,0,1,.54-.45,1.27,1.27,0,0,1,.58-.19.58.58,0,0,1,.44.15,1,1,0,0,1,.27.48,2.55,2.55,0,0,1,.1.78v.22a.41.41,0,0,1,0,.18.36.36,0,0,1-.11.13L189.16,294v.05a.82.82,0,0,0,.24.69.56.56,0,0,0,.59-.05,1.64,1.64,0,0,0,.5-.41,3,3,0,0,0,.27-.43.58.58,0,0,1,.08-.14.35.35,0,0,1,.11-.08l.18-.11a.13.13,0,0,1,.12,0,.12.12,0,0,1,0,.13,1.89,1.89,0,0,1-.1.37,2.34,2.34,0,0,1-.25.46,3.29,3.29,0,0,1-.39.48,3.56,3.56,0,0,1-.56.42,1.16,1.16,0,0,1-.54.17.61.61,0,0,1-.41-.15,1,1,0,0,1-.29-.41,2.26,2.26,0,0,1-.13-.64A4.57,4.57,0,0,1,188.62,293.62Zm.54-.28,1.68-1v0a.74.74,0,0,0-.23-.64c-.16-.11-.36-.09-.62.06a1.52,1.52,0,0,0-.32.26,1.64,1.64,0,0,0-.26.37,1.7,1.7,0,0,0-.18.44,1.59,1.59,0,0,0-.07.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.69,289a.11.11,0,0,1,.11,0,.14.14,0,0,1,0,.12v.26a.41.41,0,0,1,0,.18.36.36,0,0,1-.11.13l-.35.2a1.39,1.39,0,0,0-.69,1.31v2.34a.41.41,0,0,1-.05.18.36.36,0,0,1-.11.13l-.22.12a.11.11,0,0,1-.12,0,.17.17,0,0,1-.05-.13v-3.72a.41.41,0,0,1,.05-.18.3.3,0,0,1,.12-.13l.22-.13a.11.11,0,0,1,.11,0,.16.16,0,0,1,.05.13v.24a1.66,1.66,0,0,1,.29-.51,1.42,1.42,0,0,1,.43-.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.24,288c0-.08.08-.17.12-.27s.11-.18.17-.27a1.64,1.64,0,0,1,.22-.25A1.69,1.69,0,0,1,197,287a1,1,0,0,1,.61-.17.52.52,0,0,1,.37.3c.06-.12.11-.25.17-.37a3,3,0,0,1,.2-.34,2.52,2.52,0,0,1,.27-.3,1.87,1.87,0,0,1,.34-.25c.4-.23.7-.24.88,0a1.83,1.83,0,0,1,.28,1.16v2.21a.41.41,0,0,1,0,.18.26.26,0,0,1-.12.13l-.22.13a.08.08,0,0,1-.11,0,.14.14,0,0,1,0-.12V287.4a1.23,1.23,0,0,0-.18-.8c-.12-.12-.3-.12-.53,0a1.3,1.3,0,0,0-.51.57,2.2,2.2,0,0,0-.19,1v2.18a.41.41,0,0,1,0,.18.26.26,0,0,1-.12.13l-.22.13a.08.08,0,0,1-.11,0,.14.14,0,0,1,0-.12v-2.13a1.26,1.26,0,0,0-.18-.81c-.12-.12-.29-.12-.53,0a1.3,1.3,0,0,0-.51.57,2.2,2.2,0,0,0-.19,1v2.19a.49.49,0,0,1-.05.18.36.36,0,0,1-.11.13l-.22.12a.11.11,0,0,1-.12,0,.17.17,0,0,1-.05-.13v-3.72a.41.41,0,0,1,.05-.18.26.26,0,0,1,.12-.13l.22-.13a.11.11,0,0,1,.11,0,.14.14,0,0,1,.05.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.88,286.54a4.17,4.17,0,0,1,.13-.76,4.48,4.48,0,0,1,.28-.72,3.38,3.38,0,0,1,.42-.62,2.31,2.31,0,0,1,.54-.45,1.27,1.27,0,0,1,.58-.19.67.67,0,0,1,.44.15,1,1,0,0,1,.27.48,2.62,2.62,0,0,1,.1.79v.21a.41.41,0,0,1,0,.18.26.26,0,0,1-.12.13l-2.06,1.19V287a.83.83,0,0,0,.25.69.54.54,0,0,0,.59-.05,1.64,1.64,0,0,0,.5-.41,2.46,2.46,0,0,0,.26-.43.92.92,0,0,1,.09-.13.45.45,0,0,1,.1-.09l.19-.1a.11.11,0,0,1,.12,0s0,.07,0,.13a1.83,1.83,0,0,1-.11.37,1.85,1.85,0,0,1-.24.46,3.29,3.29,0,0,1-.39.48,2.65,2.65,0,0,1-.56.42,1.16,1.16,0,0,1-.54.17.66.66,0,0,1-.41-.14,1,1,0,0,1-.29-.41,2.34,2.34,0,0,1-.13-.65A4.57,4.57,0,0,1,200.88,286.54Zm.53-.28,1.69-1v0a.74.74,0,0,0-.23-.64c-.16-.11-.36-.09-.62.06a1.92,1.92,0,0,0-.32.26,1.9,1.9,0,0,0-.26.37,1.77,1.77,0,0,0-.18.45,1.85,1.85,0,0,0-.08.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.94,316a.64.64,0,0,1-.3-.08.6.6,0,0,1-.3-.53v-6.74a.58.58,0,0,1,.3-.52l5.06-2.93a.64.64,0,0,1,.6,0,.6.6,0,0,1,.3.53v6.74a.58.58,0,0,1-.3.52l-5.06,2.93A.64.64,0,0,1,155.94,316Zm.6-7v5.35l3.86-2.22v-5.36Zm4.46,3.47h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.74,312.18a.75.75,0,0,1-.46-.15l-1.22-.92a.77.77,0,0,1-.15-1.07.76.76,0,0,1,1.07-.14l.45.34L160.3,306a.76.76,0,0,1,1.4.61l-2.26,5.16a.78.78,0,0,1-.51.43A.62.62,0,0,1,158.74,312.18Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.49,393.53a2.31,2.31,0,0,1-1.18-.31,3.7,3.7,0,0,1-1.5-3.36V379.38c0-2.85,1.68-6.05,3.84-7.3l95.21-55a2.82,2.82,0,0,1,2.88-.19,3.72,3.72,0,0,1,1.5,3.36v10.48a9.05,9.05,0,0,1-3.84,7.3h0l-95.21,55A3.48,3.48,0,0,1,157.49,393.53Zm98-75.85a2.4,2.4,0,0,0-1.14.36l-95.21,55c-1.83,1.05-3.31,3.91-3.31,6.37v10.48a2.69,2.69,0,0,0,1,2.43,1.83,1.83,0,0,0,1.8-.19l95.21-55a8,8,0,0,0,3.3-6.37V320.28a2.72,2.72,0,0,0-1-2.43A1.3,1.3,0,0,0,255.54,317.68Zm-1.41,19.91h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.55,378a.41.41,0,0,1-.21-.76l78-45a.4.4,0,0,1,.55.15.41.41,0,0,1-.15.55l-77.95,45A.41.41,0,0,1,167.55,378Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5,424.61a2.32,2.32,0,0,1-1.19-.31,3.7,3.7,0,0,1-1.5-3.36V410.46c0-2.85,1.68-6,3.84-7.3l95.21-55a2.82,2.82,0,0,1,2.88-.19,3.72,3.72,0,0,1,1.5,3.36v10.48a9.05,9.05,0,0,1-3.84,7.3h0l-95.21,55A3.47,3.47,0,0,1,157.5,424.61Zm98-75.85a2.4,2.4,0,0,0-1.14.36l-95.21,55c-1.83,1.05-3.31,3.91-3.31,6.37v10.48a2.69,2.69,0,0,0,1,2.43,1.83,1.83,0,0,0,1.8-.19l95.21-55a8,8,0,0,0,3.3-6.37V351.36a2.72,2.72,0,0,0-1-2.43A1.3,1.3,0,0,0,255.54,348.76Zm-1.41,19.91h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.55,409.06a.41.41,0,0,1-.21-.76l78-45a.4.4,0,0,1,.55.15.41.41,0,0,1-.15.55l-77.95,45A.41.41,0,0,1,167.55,409.06Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.46,268.61a2.27,2.27,0,0,0-2.33.19l-95.21,55c-2,1.14-3.58,4.2-3.58,6.83v16.22a3.18,3.18,0,0,0,1.23,2.89l4.07,2.34a2.28,2.28,0,0,0,2.34-.18l95.21-55c2-1.14,3.57-4.2,3.57-6.83V273.85a3.2,3.2,0,0,0-1.23-2.9Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.64,352.05l-4.07-2.35a3.16,3.16,0,0,1-1.23-2.88V330.59a8.8,8.8,0,0,1,1.07-4l4.06,2.34a8.81,8.81,0,0,0-1.07,4v16.22A3.16,3.16,0,0,0,160.64,352.05Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.46,268.61l4,2.3a2.34,2.34,0,0,0-2.28.23l-95.21,55a7,7,0,0,0-2.51,2.82l-4.06-2.34a7,7,0,0,1,2.5-2.82l95.22-55A2.27,2.27,0,0,1,256.46,268.61Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.19,296.9l-95.21,55c-2,1.14-3.58-.07-3.58-2.71V332.94c0-2.63,1.6-5.69,3.58-6.83l95.21-55c2-1.14,3.57.07,3.57,2.71v16.22C261.76,292.7,260.16,295.76,258.19,296.9Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163,326.11c9.42-5.67,18.89-11.25,28.37-16.82l28.5-16.58,28.61-16.39,7.17-4.07,1.8-1a4.54,4.54,0,0,1,2-.79,2.08,2.08,0,0,1,1.14.23,2.45,2.45,0,0,1,.84.79,4.1,4.1,0,0,1,.57,2.1l-.24,16.5-.25-16.48a3.69,3.69,0,0,0-.53-1.83,1.56,1.56,0,0,0-1.5-.75,4,4,0,0,0-1.75.75l-1.78,1-7.1,4.18-28.51,16.59L191.73,310C182.17,315.38,172.6,320.8,163,326.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.36,314.69a3.29,3.29,0,0,1,1.19-.45,1.55,1.55,0,0,1,.86.11,1.14,1.14,0,0,1,.52.5,1.76,1.76,0,0,1,.2.71.58.58,0,0,1-.08.31.51.51,0,0,1-.2.21l-.7.41c-.12.07-.2.09-.26.06a.29.29,0,0,1-.15-.14.7.7,0,0,0-.46-.32,1.39,1.39,0,0,0-.92.28,2.8,2.8,0,0,0-.49.36,3,3,0,0,0-.42.45,1.88,1.88,0,0,0-.27.5,1.43,1.43,0,0,0-.11.52.86.86,0,0,0,.1.45.39.39,0,0,0,.32.15,2.23,2.23,0,0,0,.6-.09c.25-.06.56-.14.93-.25a4.19,4.19,0,0,1,1-.19,1.31,1.31,0,0,1,.72.15,1,1,0,0,1,.41.52,2.5,2.5,0,0,1,.14.9,4.17,4.17,0,0,1-.2,1.24,5.44,5.44,0,0,1-.58,1.22,6.24,6.24,0,0,1-.91,1.11,6.1,6.1,0,0,1-1.22.92,3.67,3.67,0,0,1-1.08.44,1.91,1.91,0,0,1-.92,0,1.22,1.22,0,0,1-.64-.46,1.73,1.73,0,0,1-.27-.92.56.56,0,0,1,.08-.3.6.6,0,0,1,.19-.22l.71-.41a.44.44,0,0,1,.26-.07.26.26,0,0,1,.15.16,2.2,2.2,0,0,0,.17.25.45.45,0,0,0,.28.15,1,1,0,0,0,.42,0,2.85,2.85,0,0,0,.65-.29,4.29,4.29,0,0,0,.58-.4,2.79,2.79,0,0,0,.49-.48,2.54,2.54,0,0,0,.35-.55,1.53,1.53,0,0,0,.13-.59.48.48,0,0,0-.14-.4.57.57,0,0,0-.43-.08,4.34,4.34,0,0,0-.71.15c-.29.09-.61.17-1,.26a3.46,3.46,0,0,1-.88.13,1.15,1.15,0,0,1-.63-.19,1.08,1.08,0,0,1-.36-.54,2.94,2.94,0,0,1-.13-1,3.88,3.88,0,0,1,.21-1.23,4.93,4.93,0,0,1,.55-1.19,6,6,0,0,1,.84-1.06A5.27,5.27,0,0,1,197.36,314.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.48,311.73a.17.17,0,0,1,.19,0,.26.26,0,0,1,.08.21V313a.67.67,0,0,1-.08.3.6.6,0,0,1-.19.22l-.87.5a.16.16,0,0,1-.19,0,.23.23,0,0,1-.08-.21v-1a.62.62,0,0,1,.08-.31.44.44,0,0,1,.19-.21Zm.22,9.06a.67.67,0,0,1-.08.3.62.62,0,0,1-.2.22l-.76.44a.16.16,0,0,1-.19,0,.23.23,0,0,1-.08-.21v-6.26a.56.56,0,0,1,.08-.3.46.46,0,0,1,.19-.22l.76-.44a.18.18,0,0,1,.2,0,.27.27,0,0,1,.08.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.38,320.37a2.06,2.06,0,0,0,.43-.34,2.32,2.32,0,0,0,.4-.51,3,3,0,0,0,.3-.65,2.25,2.25,0,0,0,.12-.74v-.5l-.22.39a3.58,3.58,0,0,1-.31.44,4.62,4.62,0,0,1-.44.45,3,3,0,0,1-.56.41,1.63,1.63,0,0,1-.91.26,1,1,0,0,1-.69-.3,1.8,1.8,0,0,1-.46-.74,3.59,3.59,0,0,1-.18-1.08c0-.13,0-.29,0-.47s0-.34,0-.47a6,6,0,0,1,.18-1.3,6.61,6.61,0,0,1,.46-1.27,5.37,5.37,0,0,1,.69-1.1,3.36,3.36,0,0,1,.91-.79,2.29,2.29,0,0,1,.56-.24,1.45,1.45,0,0,1,.44-.05.71.71,0,0,1,.31.08.93.93,0,0,1,.22.14v-.31a.56.56,0,0,1,.08-.3.42.42,0,0,1,.19-.22l.76-.44a.17.17,0,0,1,.2,0,.26.26,0,0,1,.08.21v6.3a5.78,5.78,0,0,1-.68,2.85,5,5,0,0,1-1.88,1.91,2.9,2.9,0,0,1-1,.37,1.46,1.46,0,0,1-.76-.05,1,1,0,0,1-.51-.38,1.21,1.21,0,0,1-.21-.67.51.51,0,0,1,.07-.3.62.62,0,0,1,.2-.22l.68-.39a.21.21,0,0,1,.25,0l.17.13a.49.49,0,0,0,.36.17A1.57,1.57,0,0,0,206.38,320.37Zm-1.21-4.52a4.82,4.82,0,0,0,0,.76c0,.56.17.9.4,1a.85.85,0,0,0,.84-.1,2.32,2.32,0,0,0,.83-.87,3.22,3.22,0,0,0,.39-1.34c0-.14,0-.32,0-.52s0-.37,0-.5a1.09,1.09,0,0,0-.39-.88.78.78,0,0,0-.83.08,2.39,2.39,0,0,0-.84.86A3.36,3.36,0,0,0,205.17,315.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.24,313.54a.56.56,0,0,1-.08.3.42.42,0,0,1-.19.22l-.76.44c-.08.05-.14.05-.19,0a.23.23,0,0,1-.08-.21v-3.41a1.71,1.71,0,0,0-.29-1.13c-.19-.22-.47-.21-.86,0a2.14,2.14,0,0,0-.85,1,3.51,3.51,0,0,0-.3,1.47v3.41a.75.75,0,0,1-.08.31.51.51,0,0,1-.2.21l-.76.45a.16.16,0,0,1-.19,0,.23.23,0,0,1-.08-.21v-6.26a.56.56,0,0,1,.08-.3.46.46,0,0,1,.19-.22l.76-.44a.17.17,0,0,1,.2,0,.26.26,0,0,1,.08.21v.31a5.73,5.73,0,0,1,.61-.93,3,3,0,0,1,.84-.71,2,2,0,0,1,1-.34.89.89,0,0,1,.66.3,1.65,1.65,0,0,1,.36.8,5.69,5.69,0,0,1,.1,1.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,301.63a.16.16,0,0,1,.19,0,.23.23,0,0,1,.08.21v1.05a.56.56,0,0,1-.08.3.52.52,0,0,1-.19.22l-.86.5a.18.18,0,0,1-.2,0,.26.26,0,0,1-.08-.21v-1.05a.71.71,0,0,1,.08-.3.62.62,0,0,1,.2-.22Zm.22,9.05a.62.62,0,0,1-.08.31.44.44,0,0,1-.19.21l-.76.45a.16.16,0,0,1-.19,0,.23.23,0,0,1-.09-.21v-6.26a.58.58,0,0,1,.09-.3.42.42,0,0,1,.19-.22l.76-.44c.08-.05.14-.05.19,0a.23.23,0,0,1,.08.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.5,307a.56.56,0,0,1-.08.3.42.42,0,0,1-.19.22l-.76.44a.17.17,0,0,1-.2,0,.26.26,0,0,1-.08-.21v-3.42a1.7,1.7,0,0,0-.28-1.12c-.19-.22-.47-.21-.86,0a2.14,2.14,0,0,0-.85,1,3.51,3.51,0,0,0-.3,1.47v3.41a.75.75,0,0,1-.08.31.51.51,0,0,1-.2.21l-.76.45a.16.16,0,0,1-.19,0,.23.23,0,0,1-.08-.21v-6.26a.56.56,0,0,1,.08-.3.42.42,0,0,1,.19-.22l.76-.44a.17.17,0,0,1,.2,0,.26.26,0,0,1,.08.21v.31a5.73,5.73,0,0,1,.61-.93,3,3,0,0,1,.84-.71,2,2,0,0,1,1-.34.89.89,0,0,1,.66.3,1.66,1.66,0,0,1,.36.79,5.73,5.73,0,0,1,.1,1.15Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.17,419.84l3.8-2.19a4.62,4.62,0,0,1,4.19-.08,1.35,1.35,0,0,1,.8,1.13v1.67a1.59,1.59,0,0,1-.93,1.26l-3.79,2.19a4.68,4.68,0,0,1-4.2.08,1.39,1.39,0,0,1-.8-1.12v-1.69A1.57,1.57,0,0,1,397.17,419.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,420l-3.79,2.19a4.64,4.64,0,0,1-4.2.08c-1.12-.65-1.06-1.73.13-2.42l3.8-2.19a4.62,4.62,0,0,1,4.19-.08C406.29,418.22,406.23,419.3,405,420Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,435.28l3.8-2.2a4.62,4.62,0,0,1,4.19-.07,1.35,1.35,0,0,1,.8,1.13v1.67a1.6,1.6,0,0,1-.93,1.26l-3.8,2.19a4.62,4.62,0,0,1-4.19.07,1.36,1.36,0,0,1-.8-1.12c0-.28,0-1.39,0-1.68A1.57,1.57,0,0,1,370.4,435.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26,435.43l-3.8,2.19a4.62,4.62,0,0,1-4.19.08c-1.12-.65-1.06-1.73.13-2.42l3.8-2.2a4.62,4.62,0,0,1,4.19-.07C379.51,433.66,379.45,434.74,378.26,435.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.5,397.61l3.8-2.19a4.62,4.62,0,0,1,4.19-.07,1.33,1.33,0,0,1,.8,1.12c0,.29,0,1.39,0,1.68a1.6,1.6,0,0,1-.93,1.26l-3.79,2.19a4.64,4.64,0,0,1-4.2.07,1.33,1.33,0,0,1-.79-1.12c0-.29,0-1.39,0-1.69A1.62,1.62,0,0,1,358.5,397.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.36,397.77,362.57,400a4.68,4.68,0,0,1-4.2.08c-1.12-.65-1.06-1.74.13-2.43l3.8-2.19a4.62,4.62,0,0,1,4.19-.07C367.62,396,367.56,397.08,366.36,397.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.73,413.05l3.8-2.19a4.65,4.65,0,0,1,4.19-.08,1.36,1.36,0,0,1,.8,1.13v1.67a1.59,1.59,0,0,1-.93,1.26L335.8,417a4.64,4.64,0,0,1-4.2.08,1.37,1.37,0,0,1-.8-1.12V414.3A1.59,1.59,0,0,1,331.73,413.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.59,413.21l-3.79,2.19a4.64,4.64,0,0,1-4.2.07c-1.12-.64-1.06-1.73.13-2.42l3.8-2.19a4.65,4.65,0,0,1,4.19-.08C340.85,411.43,340.79,412.52,339.59,413.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.26,420.45a3,3,0,0,1-1.58-.44,3.78,3.78,0,0,1-1.44-3.72L332,273.52l2,.17L322.24,416.45c-.08.92.11,1.61.51,1.87s1.11.13,1.91-.33l42.19-24.36a8.26,8.26,0,0,0,3.68-6.6l-3.92-133.37,2-.06L372.53,387a10.19,10.19,0,0,1-4.68,8.39l-42.19,24.36A4.83,4.83,0,0,1,323.26,420.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.65,
    y: 365.03,
    width: 2,
    height: 41.66,
    transform: "translate(-162.84 489.68) rotate(-60)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.5,
    y: 339.42,
    width: 2,
    height: 41.72,
    transform: "translate(-117.76 516.59) rotate(-60)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.84,442.73a3.08,3.08,0,0,1-1.61-.43,3.94,3.94,0,0,1-1.67-3.69l3.93-147.44,2,.05-3.93,147.44a1.6,1.6,0,0,0,2.7,1.61l42.19-24.36a7.6,7.6,0,0,0,3.41-6.53L397.1,271.3l2-.17,11.76,138.08a9.52,9.52,0,0,1-4.4,8.43L364.26,442A4.94,4.94,0,0,1,361.84,442.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.82,258.65c15.87-9.16,41.59-9.16,57.45,0,7.93,4.57,11.89,10.58,11.89,16.58v7.37c0,6-4,12-11.89,16.58-15.86,9.16-41.58,9.16-57.45,0-7.93-4.58-11.89-10.58-11.88-16.58v-7.37C324.93,269.23,328.89,263.22,336.82,258.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.82,255.07c15.87-9.16,41.59-9.16,57.45,0,7.93,4.57,11.89,10.58,11.89,16.58V279c0,6-4,12-11.89,16.58-15.86,9.16-41.58,9.16-57.45,0C328.89,291,324.93,285,324.94,279v-7.37C324.93,265.65,328.89,259.64,336.82,255.07Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.82,255.07c15.87-9.16,41.59-9.16,57.45,0,7.93,4.57,11.89,10.58,11.89,16.58V279c0,6-4,12-11.89,16.58-15.86,9.16-41.58,9.16-57.45,0C328.89,291,324.93,285,324.94,279v-7.37C324.93,265.65,328.89,259.64,336.82,255.07Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.55,
    cy: 271.65,
    rx: 40.62,
    ry: 23.45,
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.55,
    cy: 271.65,
    rx: 40.62,
    ry: 23.45,
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.72,296.64c2.86,1.69,5.86-.87,8.89.95a9.36,9.36,0,0,1,4.28,5.67,12.38,12.38,0,0,0,1.23,3.54c.88,1.24,1.78,2.48,2.64,3.75a54.17,54.17,0,0,0,4.64,5.61c4,4.38,4.87,10.94,4.07,16.68-.42,3-1.79,3.86-3.29,6.48-1,1.8-2.92,3.92-5.14,3.74s-3.9-2.08-5-3.86c-1.35-2.19-1-3.21-1.82-5.62s-1.92-5.84-3.86-7.4a62.23,62.23,0,0,1-4.55-4.35c-2.72-2.72-5.41-5.48-8.07-8.25l-.81-.85c-2.64-2.55-14.55-9.53-14.55-9.53L331.24,284Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,297a6,6,0,0,1,4.05,1.1,19.29,19.29,0,0,1,2.61,7.09c.64,3.49.95,4.88,2.95,6.65a23.34,23.34,0,0,1,6.63,8.09,19,19,0,0,1,.63,16c-2.53,6.54-4.83,7.88-6.59,8.53s-4.71,0-4.71,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.62,295.43l1.1,1.21a16.9,16.9,0,0,1,1.82,1.95c2.23,3,1.31,9.13,1,10.78a3.67,3.67,0,0,0-3,.58c-2.08,1.22-5.48,3.68-5.3,4.82s7.06,5.94,10.37,10.57,3.59,7,4.47,11.53c.63,3.21,2.87,8.63,7.46,7.4,2.4-.61,8.42-4.95,9.21-15.22.7-9.12-5.3-13.78-8.39-16.54s-3.29-5.4-4.73-10.2c-.63-2.09-1-3.74-3.09-5.3-2.86-1.12-5.87-.59-8-1C342.76,295.65,342.21,294.53,341.62,295.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.54,309.37a2,2,0,0,0,0,1.42,4.15,4.15,0,0,0,.87,1.14c.66.66,1.29,1.31,1.92,2,1.29,1.32,2.54,2.65,3.74,4a51.81,51.81,0,0,1,3.37,4.33,24.87,24.87,0,0,1,2.64,4.84,17,17,0,0,0-2.09-5.2,30.59,30.59,0,0,0-3.27-4.54,48.88,48.88,0,0,0-3.89-4c-.68-.62-1.4-1.22-2.11-1.8a4.91,4.91,0,0,1-1-.91A2.34,2.34,0,0,1,345.54,309.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.35,325.32c-2.36.32-7.69,3.16-7.81,5.44l.23.62a3,3,0,0,1-.94-1.74c-.25-1.23,2.64-4.44,7.87-5.59C358.43,324.23,359,325.16,358.35,325.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.78,321.3c-2.38.19-7.33,2.66-7.58,4.93l.29.45a1.7,1.7,0,0,1-1-1.5c-.18-1.24,2.43-4.34,7.72-5.17C355.92,320.22,356.48,321.18,355.78,321.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.81,317.46c-2.33.39-7.25,3.09-7.29,5.39l.43.47a2.14,2.14,0,0,1-1.23-1.25c-.4-1.23,2.27-4.58,7.42-5.87C352.86,316.36,353.49,317.28,352.81,317.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.11,314.3c-2.33.39-7.6,3.22-7.64,5.52l.46.47a2.51,2.51,0,0,1-1.3-1.33c-.4-1.23,2.65-4.63,7.8-5.91C350.15,313.2,350.79,314.12,350.11,314.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.74,230.32c-.1,3.23-19.78,8.81-33.79,13.34-16.08,5.21-23.74,8.93-29.66,14.92a14.15,14.15,0,0,0-4.24,13.11c.74,4,4.19,10.4,11.76,16.35,14.36,11.29,21.31,13.91,31.43,20.41,0,0,10.31-6.87,11.91-14.79L326.7,277.93,368,265.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.86,294.44c-.25,3-.47,6.21-.65,9.16,2.58,1.49,5.18,3,8,4.85,0,0,10.31-6.87,11.91-14.79L328.5,279.88C324.25,284.12,322.54,286,321.86,294.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,265.57l-1.3-2.68s-23.91,5.69-32.21,7.62c-7,1.64-8.44,1.88-12-1.26-5-4.35-8.45-5-11.91-4.2,5.27.63,10.89,6.54,16.16,12.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.48,254.15l-25.2,22.11L368,265.57,357.37,237.2l-5.73,3.23C351.61,246.4,353.77,250.07,357.48,254.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,362.35c.77,2.85,3,6.78,2.33,10.51a10,10,0,0,1-4,6.4,12.56,12.56,0,0,0-3,2.52c-.89,1.34-1.79,2.7-2.71,4-1.48,2.14-2.71,3.24-3.89,5.57-2.85,5.64-9,8.91-14.88,10.17a21.82,21.82,0,0,1-8.92.28c-2.13-.39-4.9-1.54-5.52-3.86s.63-4.7,2-6.46c1.65-2.15,4.16-3.48,6.23-5.13a30,30,0,0,0,5.86-6.6c1.71-2.7,8-11.1,8.07-18.72.06-4.82-1.18-24.9-1.18-24.9l21.64,1.5S342.26,359.49,343,362.35Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27,373.58a6.73,6.73,0,0,1,.38,4.5,20,20,0,0,1-6,5.21c-3.18,1.91-4.43,2.73-5.45,5.4s-1.61,5.46-5,9S321,403.87,312.53,404c-7.33.1-9.86-2.55-10.49-3.26a9.18,9.18,0,0,1-1.69-4.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,360.33c-.09.78-.05,1.59-.06,2.51a5.14,5.14,0,0,1-1.22,3c-2.3,2.78-6.72,4-8.45,4.25a4.56,4.56,0,0,0-2.36-2.47c-3.42-1.78-7.27-2.51-8.33-1.92s-2.55,6.91-5.89,11.95-6.57,7.25-11.05,10.55c-2.76,2-7.45,5.46-4.59,9.67,1.47,2.21,8.71,5.13,19.05,2.21,9.19-2.59,12.24-8.87,13.82-13s4.1-5.29,8.29-8.49c1.82-1.39,3.32-2.33,4.08-5,.06-3.31-1.6-7.32-2-9.66C344,362,344.07,360.61,343,360.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.25,370.12a2.5,2.5,0,0,0-2.19,1.84,28.71,28.71,0,0,1-1.75,3.44C326.2,380.32,323,385,318.73,389c5-3.27,8.16-7.93,11-13a26.48,26.48,0,0,0,1.79-3.79C331.78,371.17,332.2,370.35,333.25,370.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.72,387.94c-2.22-3.53-6.9-5-9.18-4.31l-.53.45a3.12,3.12,0,0,1,1.37-1.58c1.12-.7,6.33-.56,9.34,4.33C321.81,387.63,321.12,388.58,320.72,387.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.94,384.18c-1.91-3.41-7.41-5.08-9.72-4.51l-.38.48a2,2,0,0,1,1.15-1.58c1.16-.63,7.54.15,10,4.56C326.05,383.93,325.31,384.84,324.94,384.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,379.88c-1.39-2.92-7.75-5.2-10-4.4l-.35.65a2.58,2.58,0,0,1,.82-1.75c1.07-.84,7.89.37,10.54,4.36C329.07,379.53,328.39,380.5,328,379.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.93,376c-1.17-3.22-7.82-5-10.09-4.23l-.43.83a2.18,2.18,0,0,1,.72-1.69c1.07-.85,7.66-.81,10.78,3.94C331,375.6,330.35,376.59,329.93,376Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.74,230.32h0l58.39,4.19c1.11,7.88-.22,19.17-2.31,25.9-1.92,6.16-6.18,13.47-18,20.42-14,8.25-31.22,15.75-34.53,17.89-4.78,3.09-7.33,2.17-7.51,13.88-.11,7.5-2,16.8-3.31,23.94-1.22,6.8-2.62,15.56-2.62,15.56-2.38,3.52-15.71,5.65-19.86,1,0,0-2.63-41.15-1.84-56.41.28-5.36,3.05-10.39,8.95-16.67,5.05-5.37,30.32-25.18,30.32-25.18S345.73,243.25,353.74,230.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.11,238.26c1.34,13.08,2.14,21-15,31.06-5.17,3-10.55,5.94-15.75,8.76-15.43,8.35-27.61,14.94-28.14,21-.21,2.3-.26,5-.31,8.18-.13,7.47-.5,9.54-1.94,20.35-1.26,9.42-2.9,21.7-4.33,27.76.55-.09,1.07-.19,1.57-.32,1.43-6.07,2.92-18.28,4.18-27.13,1.66-11.58,1.84-13.1,2-20.63.06-3.13.11-5.83.31-8.08.46-5.22,13.53-12.29,27.37-19.79,5.22-2.82,10.61-5.73,15.79-8.78,18-10.56,17.07-19.29,15.72-32.5-.12-1.25-.25-2.55-.37-3.89l-1.48-.22C402.83,235.47,403,236.89,403.11,238.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.59,267.23c-.23-.15-5.62-3.84-3.7-13.52,2.1-10.56,1.58-15.43.56-22.5l1.44-.21c1.05,7.25,1.53,12.42-.57,23-1.73,8.69,3,11.94,3.06,12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.54,347.89c2.77,3.16,14.87,3.9,21.15-.8l-.81,6.32c-4.58,4.47-14.16,5.75-20.08,1.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.11,160.39c-8.37,1-15.19,2.91-19.89,10-4.81,7.26-10.35,16.17-17.59,27.3l-19-8.88L308,202s20.43,13.13,28,15.68c5.65,1.91,7-.58,11.16-4.94,4.64-4.85,18.29-20.69,18.29-20.69Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.63,197.68c3.21,1.08,6.62,4.14,7.21,6-1.85-5.62-4.76-6.64-6.3-7.38Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.16,173.49h0l1.47-1.38v0a1.69,1.69,0,0,1,1.56-.23l16.68,3.85a6.07,6.07,0,0,1,3.86,3.33L329,213a1.56,1.56,0,0,1-.15,1.76h0l-1.52,1.42v0a1.73,1.73,0,0,1-1.58.25l-16.68-3.85a6.12,6.12,0,0,1-3.86-3.33c-2.61-6.67-10.69-27.26-13.3-33.92C291.6,174.48,291.72,173.84,292.16,173.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.21,178a6,6,0,0,1,2,2.45l13.3,33.91a1.65,1.65,0,0,1-.09,1.73l1.43-1.33h0A1.57,1.57,0,0,0,329,213l-13.3-33.92a5.82,5.82,0,0,0-1.87-2.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.53,214.38l-13.3-33.92a6.12,6.12,0,0,0-3.86-3.33l-16.68-3.85c-1.55-.36-2.34.55-1.76,2,2.61,6.66,10.69,27.25,13.3,33.92a6.12,6.12,0,0,0,3.86,3.33l16.68,3.85C327.32,216.78,328.11,215.86,327.53,214.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.5,187.67,312,181.33a1.16,1.16,0,0,0-.72-.63l-3.14-.72c-.29-.06-.44.11-.33.38l2.49,6.35a1.16,1.16,0,0,0,.72.63l3.14.72C314.46,188.12,314.61,188,314.5,187.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.92,182.87a2.89,2.89,0,0,0-1.84-1.53c-.75-.18-1.15.23-.88.91a2.89,2.89,0,0,0,1.84,1.53C311.79,184,312.18,183.55,311.92,182.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.13,186.08a2.85,2.85,0,0,0-1.84-1.54c-.75-.17-1.14.24-.87.91a2.86,2.86,0,0,0,1.83,1.54C313,187.16,313.4,186.75,313.13,186.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.78,195.82c-1.73-1.94-1.62-2.23-.93-3.4a6.68,6.68,0,0,1,5.08-3.34c1.85-.15,3.71-.39,4.72,0s.42,2.48-1.93,3.28c-3.7,1.27-3.56,2.29-3.56,2.29a47.23,47.23,0,0,1,4.8-1.39,35.55,35.55,0,0,1,5.65.23c1.63.08,2.17,2.11-.46,3.11l3,.15c2.08.11,2.9,1.12,1.43,2.57a3,3,0,0,1-1.78.9s2.18-.24,2.31.48c.36,2.07-.93,2.76-5.21,4.53-4.07,1.68-4.69,4-3.69,5.51,0,0-1.8-.8-3.42-1.68-1.19-.64-2.23-1.4-1.92-3.18,0,0-2.4.31-2.71-1.16a7.64,7.64,0,0,1,.24-3.25,2.64,2.64,0,0,1-1.6-2.33,4.28,4.28,0,0,1,.59-2.71Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.15,196.6a14.34,14.34,0,0,0-2.7,0,8.47,8.47,0,0,0-2.48,1.1,30.71,30.71,0,0,0-4.37,3,31.6,31.6,0,0,0,4.75-2.31,14,14,0,0,1,2.25-1.19C308.38,197,309.3,196.86,310.15,196.6Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.78,200.22a5.94,5.94,0,0,0-2.89.23,14.89,14.89,0,0,0-2.65,1.16,28,28,0,0,0-4.72,3.23,55,55,0,0,0,5.1-2.54A15,15,0,0,1,312.78,200.22Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.47,157.4,407,161.81c2.82,1,13.64,11.66,9.91,27.72-1,4.35-2.48,11.27-4.41,20.91-.77,3.83.1,7.44.45,11.74.57,7,0,16.33-.45,23.47,0,0-7.84,6-35.89,2.81-21.39-2.42-27.25-14.91-27.25-14.91,2-6.14,4.58-10.3,7.67-16.16a59.93,59.93,0,0,1-.49-13.17,19.53,19.53,0,0,1-6.43-12c-1-7,2.29-12.07,9-19.87a65.94,65.94,0,0,1,13-12Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.89,101.88a16.34,16.34,0,0,0,2.55,2.92c1.36,1,3.08,1,4.68,1.22s3.38.82,4.14,2.39c1.11,2.32-.61,5.36.44,7.72.65,1.48,2.17,2.19,3.5,3s2.72,2,2.75,3.59c0,2-2,3.49-2,5.5s2.31,3.67,1.94,5.7a3.5,3.5,0,0,1-2.43,2.4,9.68,9.68,0,0,0-3.17,1.38c-2.08,1.79-1.8,5.81-4.09,7.26-1.21.78-2.76.54-4,1.16-2.3,1.12-3.06,4.62-5.4,5.61s-4.6-.81-6.95-.69-4.4,2-6.61,1.43-3.5-3.41-5.61-4.54c-3.33-1.76-7.8,1.19-10.83-1.14-2-1.51-2.49-4.88-4.9-5.76a14.6,14.6,0,0,0-1.95-.48,6,6,0,0,1-2.58-1.27,7,7,0,0,1-2.36-4.8c-.09-1.45.22-3-.4-4.29-.86-1.76-3.1-2.21-4-3.92-1-1.87,0-4.28,1.27-6s2.87-3.27,3.16-5.43c.26-1.86-.54-3.86.14-5.6a5.45,5.45,0,0,1,3.53-2.8c1.43-.5,3-.92,4-2.11l.11-.13c1.17-1.46,1.58-3.59,3.15-4.73a6.28,6.28,0,0,1,4.55-.78c2.16.32,3.48,1.2,5.62.42,1.36-.5,2.46-1.74,3.87-2s2.77.45,4,1.09a5.93,5.93,0,0,0,3.41,1,29,29,0,0,1,3.08-.63,9.18,9.18,0,0,1,3.83.68A9.31,9.31,0,0,1,402.89,101.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.16,112.43c-4.18-5.6-16.65-10.35-26.24-6.91-8.56,2-14,9.92-14.33,20.43.94,13,31.81,27.56,31.81,27.56.31-2.15,3.53-6.21,6.05-10.43a79.24,79.24,0,0,0,4.41-8.77C409.31,130.07,410.33,119.35,405.16,112.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.34,156.47c0-2,.38-12,.38-12,0,.48,1.6,1.53,3.59,1.14,3.23-.64,9.67-10.24,3.8-13.79-2.46-1.49-6-.92-7.67,3-2.18.5-3.52-1.69-3.29-4.6.36-4.65-2.35-7.76-6.19-10.4-2.77-1.9-6.89-4-8.78-6.54-4.87,4-11.1,3.42-13.4,9.35a108.13,108.13,0,0,0-.25,11.82c.09,9.94,2.24,15.69,5.72,17.28a15.76,15.76,0,0,0,8.38,1.31l-.22,3.32h0c-.09,1.66,0,2.57-1.58,3.06a15.3,15.3,0,0,1-2,.46s-5.95,4.59,4.34,6.07c15.37,2.19,24-5.25,24-5.25s-1.38-.38-3.92-1.18C396.52,158.73,396.34,158.45,396.34,156.47Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.65,141.14l-5.58,1.72a2.87,2.87,0,0,0,3.6,2A3.07,3.07,0,0,0,382.65,141.14Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.28,142.42a3.2,3.2,0,0,0-3.23,2.47,2.71,2.71,0,0,0,1.62,0,3,3,0,0,0,2-2.41A2,2,0,0,0,382.28,142.42Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.42,126.22l4-2a2.16,2.16,0,0,0-2.95-1A2.35,2.35,0,0,0,366.42,126.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.29,126l-4.1-2a2.18,2.18,0,0,1,3-1.12A2.39,2.39,0,0,1,387.29,126Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.55,130a1.92,1.92,0,0,1-1.74,2,1.8,1.8,0,0,1-2-1.67,1.92,1.92,0,0,1,1.74-2A1.8,1.8,0,0,1,371.55,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.1,130.41a1.92,1.92,0,0,1-1.74,2,1.8,1.8,0,0,1-2-1.67,1.92,1.92,0,0,1,1.74-2A1.8,1.8,0,0,1,385.1,130.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.25 136.08 376.14 138.95 377.44 127.57 370.25 136.08",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.63,153.11c7.11-.66,13.94-2.92,15.56-6.15a6.4,6.4,0,0,1-2.9,5.21c-4.07,2.34-12.82,3.45-12.82,3.45Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.06,185.1c-3.06-3-4.64-4.23-6.17-4.9s-6.79-3.76-8.85-4.59c-1.31-.52-2.16,1.56-.64,3.28,1.18,1.33,4.43,3.3,5.83,4.34s3.89,5.07,3.89,5.07Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.19,175.16c-2.48-8.64-7-11.95-15.16-13.35-8.74,6.44-3,30.19-3,30.19L408,205.76s-16.16-6.47-18.26-8.26a108.5,108.5,0,0,1-9.05-10c-2.46-3.1-3.91-2.93-5.37-2.91-4.8.06-5.89.31-7,.8a2.15,2.15,0,0,0-1.17,1.71c-1.27,0-3.13-.31-3.66,1.71a6.06,6.06,0,0,0-.3,1.63,1.34,1.34,0,0,0-.87.35c-1.21,1.06,0,5.48,1,6.65.7.82,1.82,1.07,3.33,1.07,1.29,0,.88-1.37.88-1.37l1.76.35c3.45,3.25,2.9,8.66,7.79,10.54a34.56,34.56,0,0,1,6,2.05c10.39,5.15,23.57,19.5,35.6,21.09,9.51,1.26,11-3.12,11.42-9C430.54,216.15,424.4,182.86,422.19,175.16Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.19,203l.79,2.77c5.56,1.72,10.94,3.41,12.33,5.6C418.94,207.76,415,205.08,407.19,203Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.16,187.11l5.74-.36-5.52-.4A2.13,2.13,0,0,0,367.16,187.11Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.2,190.45l6.54.05-6.44-.8A3.49,3.49,0,0,0,363.2,190.45Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.66,193.4a2.12,2.12,0,0,0,.76.87,4,4,0,0,0,1.05.52l-.08-.07c.13.36.26.72.4,1.07l.16-.15a1.31,1.31,0,0,0-1.06.11,1.7,1.7,0,0,0-.67.76,2,2,0,0,1,.75-.61,1.25,1.25,0,0,1,.89,0l.24.08-.08-.24c-.13-.35-.26-.71-.4-1.06l0-.06-.06,0a6.65,6.65,0,0,1-1-.44A2.46,2.46,0,0,1,363.66,193.4Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.25,194.46a19.91,19.91,0,0,0,2.31.48,2.49,2.49,0,0,0,.63,1.35,12.85,12.85,0,0,0,1.1,1.21l-1.76-.35s-.32-.85-1.87-1.37Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Warp--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.56,133.82c2.18,2.91,4,7.61,4.43,15.22.29,5.68,2.68,14.39,5.59,16.44-6,0-13.73,8.1-13.27,11.21-1.85-5-2.64-18.72-1.25-26.46a92.29,92.29,0,0,0,1.52-12.31Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.56,133.82c2.18,2.91,4,7.61,4.43,15.22.29,5.68,2.68,14.39,5.59,16.44-6,0-13.73,8.1-13.27,11.21-1.85-5-2.64-18.72-1.25-26.46a92.29,92.29,0,0,0,1.52-12.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.31,145.65c1.88-4.15-1.66-19.3-7.15-25-13.28-13.72-21-7.13-24.27-4a15.43,15.43,0,0,0-4.3,9.26c-.42-7.28,1.11-14.43,9.26-18.62,10.51-5.4,20.71-.13,25.95,4.76,8.19,7.64,8.51,16.64,7.06,22.22C406.86,134.31,402.23,143.71,400.31,145.65Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.31,145.65c1.88-4.15-1.66-19.3-7.15-25-13.28-13.72-21-7.13-24.27-4a15.43,15.43,0,0,0-4.3,9.26c-.42-7.28,1.11-14.43,9.26-18.62,10.51-5.4,20.71-.13,25.95,4.76,8.19,7.64,8.51,16.64,7.06,22.22C406.86,134.31,402.23,143.71,400.31,145.65Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.31,145.65a24.52,24.52,0,0,0-3.88,7c-1.85,4.58-7.2,16-6.72,28.3S391.89,196,391.89,196s0-2.32,2.6-6.43c3.42-5.37,8.34-2.66,12.34-9.08-2.83-7.47-4.14-12-3-25.32s.87-16.57.87-16.57S402.87,141.84,400.31,145.65Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.31,145.65a24.52,24.52,0,0,0-3.88,7c-1.85,4.58-7.2,16-6.72,28.3S391.89,196,391.89,196s0-2.32,2.6-6.43c3.42-5.37,8.34-2.66,12.34-9.08-2.83-7.47-4.14-12-3-25.32s.87-16.57.87-16.57S402.87,141.84,400.31,145.65Z",
    style: {
      opacity: 0.38
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377,88.59l-6.82-3.94a.6.6,0,0,1-.32-.29l-1.26-2.19,4.05-2.33-.12.35Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,88.59l-6.82-3.94a.6.6,0,0,1-.32-.29l-1.26-2.19,4.05-2.33-.12.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.07,80.17l4.72,8.17a.71.71,0,0,0,1.28-.12l5-14.39Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.07,80.17l4.72,8.17a.71.71,0,0,0,1.28-.12l5-14.39Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.49,32.34a7.28,7.28,0,0,0-3.3-5.71l-.72-.44a7.29,7.29,0,0,0-6.59,0L291.76,79.52a7.29,7.29,0,0,0-3.3,5.71v31.11a7.29,7.29,0,0,0,3.3,5.71l.72.44a7.29,7.29,0,0,0,6.59,0L391.5,68.93c3-1.69,3-3.38,3-5.49Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.49,32.34a7.28,7.28,0,0,0-3.3-5.71l-.72-.44a7.29,7.29,0,0,0-6.59,0L291.76,79.52a7.29,7.29,0,0,0-3.3,5.71v31.11a7.29,7.29,0,0,0,3.3,5.71l.72.44a7.29,7.29,0,0,0,6.59,0L391.5,68.93c3-1.69,3-3.38,3-5.49Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.46,116.34a7.29,7.29,0,0,0,3.3,5.71l.72.44a7.36,7.36,0,0,0,6,.27c-1.55.59-2.74-.3-2.74-2.18V89.47a6.74,6.74,0,0,1,1-3.25L289.42,82a6.8,6.8,0,0,0-1,3.25Z",
    style: {
      fill: "#EF4444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.38,31.4c-.38-1.4-1.66-1.85-3.18-1L299.07,83.77a6.42,6.42,0,0,0-2.32,2.46L289.44,82a6.57,6.57,0,0,1,2.32-2.46l92.11-53.34a7.37,7.37,0,0,1,6.6,0l.73.44A7.26,7.26,0,0,1,394.38,31.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.44,90.2a3.72,3.72,0,0,1,.13-1,4.57,4.57,0,0,1,.37-1,4.27,4.27,0,0,1,.55-.81,2.71,2.71,0,0,1,.67-.57,1.65,1.65,0,0,1,.68-.21.89.89,0,0,1,.55.18,1.14,1.14,0,0,1,.37.52,2.24,2.24,0,0,1,.13.82,3.72,3.72,0,0,1-.13,1,4.57,4.57,0,0,1-.37.95,4.27,4.27,0,0,1-.55.81,2.58,2.58,0,0,1-.68.57,1.33,1.33,0,0,1-.67.21.94.94,0,0,1-.55-.17,1.18,1.18,0,0,1-.37-.53A2.2,2.2,0,0,1,322.44,90.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,87a3.72,3.72,0,0,1,.13-1,4.57,4.57,0,0,1,.37-1,4.27,4.27,0,0,1,.55-.81,2.75,2.75,0,0,1,.68-.57,1.33,1.33,0,0,1,.67-.21.86.86,0,0,1,.55.17,1.22,1.22,0,0,1,.38.52,2.54,2.54,0,0,1,.13.83,4.19,4.19,0,0,1-.13,1,4.83,4.83,0,0,1-.38,1,3.85,3.85,0,0,1-.55.81,3,3,0,0,1-.67.57,1.61,1.61,0,0,1-.68.21.89.89,0,0,1-.55-.18,1.14,1.14,0,0,1-.37-.52A2.24,2.24,0,0,1,328,87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.6,83.75a3.65,3.65,0,0,1,.13-1,4.93,4.93,0,0,1,.37-1,4.27,4.27,0,0,1,.55-.81,2.75,2.75,0,0,1,.68-.57,1.37,1.37,0,0,1,.68-.21.82.82,0,0,1,.55.17,1.22,1.22,0,0,1,.37.52,2.26,2.26,0,0,1,.13.83,3.65,3.65,0,0,1-.13,1,4.93,4.93,0,0,1-.37,1,4.27,4.27,0,0,1-.55.81,2.75,2.75,0,0,1-.68.57,1.37,1.37,0,0,1-.68.21.82.82,0,0,1-.55-.17,1.22,1.22,0,0,1-.37-.52A2.3,2.3,0,0,1,333.6,83.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.19,80.53a3.72,3.72,0,0,1,.13-1,4.57,4.57,0,0,1,.37-1,4.27,4.27,0,0,1,.55-.81,2.71,2.71,0,0,1,.67-.57,1.51,1.51,0,0,1,.68-.21.89.89,0,0,1,.55.18,1.14,1.14,0,0,1,.37.52,2.24,2.24,0,0,1,.13.82,3.72,3.72,0,0,1-.13,1,4.57,4.57,0,0,1-.37.95,4.27,4.27,0,0,1-.55.81,2.58,2.58,0,0,1-.68.57,1.33,1.33,0,0,1-.67.21.94.94,0,0,1-.55-.17,1.18,1.18,0,0,1-.37-.53A2.2,2.2,0,0,1,339.19,80.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.77,77.31a3.72,3.72,0,0,1,.13-1,4.57,4.57,0,0,1,.37-1,4.27,4.27,0,0,1,.55-.81,2.75,2.75,0,0,1,.68-.57,1.33,1.33,0,0,1,.67-.21.86.86,0,0,1,.55.17,1.12,1.12,0,0,1,.37.52,2.29,2.29,0,0,1,.14.83,3.74,3.74,0,0,1-.14,1,4.25,4.25,0,0,1-.37.95,3.85,3.85,0,0,1-.55.81,3,3,0,0,1-.67.57,1.61,1.61,0,0,1-.68.21.89.89,0,0,1-.55-.18,1.14,1.14,0,0,1-.37-.52A2.24,2.24,0,0,1,344.77,77.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.35,74.08a3.78,3.78,0,0,1,.13-1,5.1,5.1,0,0,1,.37-.94,4.27,4.27,0,0,1,.55-.81,2.75,2.75,0,0,1,.68-.57,1.5,1.5,0,0,1,.68-.22.89.89,0,0,1,.55.18,1.22,1.22,0,0,1,.37.52,2.26,2.26,0,0,1,.13.83,3.65,3.65,0,0,1-.13,1,4.93,4.93,0,0,1-.37,1,4.27,4.27,0,0,1-.55.81,2.75,2.75,0,0,1-.68.57,1.37,1.37,0,0,1-.68.21.82.82,0,0,1-.55-.17,1.22,1.22,0,0,1-.37-.52A2.3,2.3,0,0,1,350.35,74.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.93,70.86a3.74,3.74,0,0,1,.14-1,4.57,4.57,0,0,1,.37-.95,4.27,4.27,0,0,1,.55-.81,2.71,2.71,0,0,1,.67-.57,1.4,1.4,0,0,1,.68-.21.89.89,0,0,1,.55.18,1.14,1.14,0,0,1,.37.52,2.24,2.24,0,0,1,.13.82,3.72,3.72,0,0,1-.13,1,4.57,4.57,0,0,1-.37,1,4.27,4.27,0,0,1-.55.81,2.58,2.58,0,0,1-.68.57,1.33,1.33,0,0,1-.67.21.94.94,0,0,1-.55-.17,1.18,1.18,0,0,1-.37-.53A2.19,2.19,0,0,1,355.93,70.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.52,67.64a3.67,3.67,0,0,1,.13-1,4.57,4.57,0,0,1,.37-1,4.27,4.27,0,0,1,.55-.81,2.75,2.75,0,0,1,.68-.57,1.33,1.33,0,0,1,.67-.21.86.86,0,0,1,.55.17,1.2,1.2,0,0,1,.37.52,2.29,2.29,0,0,1,.14.83,3.74,3.74,0,0,1-.14,1,4.48,4.48,0,0,1-.37.94,3.67,3.67,0,0,1-.55.82,2.66,2.66,0,0,1-.67.56,1.5,1.5,0,0,1-.68.22A.89.89,0,0,1,362,69a1.14,1.14,0,0,1-.37-.52A2.24,2.24,0,0,1,361.52,67.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.11,109.39a2.36,2.36,0,0,1-1.19-.32,3.69,3.69,0,0,1-1.5-3.35V95.23c0-2.84,1.69-6,3.84-7.29L379.86,46a2.8,2.8,0,0,1,2.88-.19,3.7,3.7,0,0,1,1.5,3.36V59.69c0,2.84-1.69,6-3.84,7.29h0l-72.6,41.9A3.36,3.36,0,0,1,306.11,109.39Zm75.43-62.78a2.4,2.4,0,0,0-1.14.36l-72.6,41.9a8,8,0,0,0-3.31,6.36v10.49a2.7,2.7,0,0,0,1,2.42,1.82,1.82,0,0,0,1.8-.19l72.6-41.9h0c1.82-1,3.3-3.91,3.3-6.36V49.21a2.72,2.72,0,0,0-1-2.43A1.3,1.3,0,0,0,381.54,46.61Zm-1.41,19.91h0Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/signin.e19bf6b138183a4266c9241dd3e1d7d6.svg";
export { ForwardRef as ReactComponent };